// Thunks extracted from LoginModule.js

import _ from "lodash";
import update from "immutability-helper";
import moment from "moment";
import axios from "lib/axiosInstance";
// import LogRocket from "logrocket";
import { Sentry } from "services/sentry";
import { store } from "store/createStore";
import {
  goToPlatformHomeRoute,
  handleQueryParameters,
  updateQueryParameters,
  goToRoute,
} from "modules/NavigationModule";
import {
  getCurrentQuery,
  getCurrentPathname,
} from "services/NavigationService";
import client from "lib/apolloClient/client";
import { cache, persistor } from "lib/apolloClient";
import ACLStore from "lib/aclStore";
import {
  SNPv2_VISITOR_PORTAL_PERM_GROUP,
  ENABLE_ACTIVITY_LOGGING,
  ENABLE_INTERCOM_CONSUMPTION,
  ENABLE_CONFIGURATION_FETCHING_OPTIMISATION,
} from "Constants/permissionConstants";
import { setPusherConnection } from "modules/PusherModule/PusherUtils";
import {
  setGA,
  getBackendServerUrl,
  getUserBrowserDetails,
  isUserTypeStaff,
  isRedirectUrlSafe,
  generateRandomNonce,
} from "Utils";
import { clearEntityFlowStore } from "Utils/EntityFlowUtils/CustomHooks";
import {
  DUMMY_USER_INFO,
  PUBLIC_USER_INFO_EU_WEST_1,
  PUBLIC_USER_INFO_US_EAST_1,
  USER_TYPE_ENTITY_MAPPING,
  APOLLO_CACHE_PERSISTENCE_EXPITATION_TIME_DURATION_IN_DAYS,
} from "Constants";
import {
  initMixPanel,
  identifyUser,
  recordTrait,
  setOrganization,
  recordEvent,
  aliasUser,
  clearIdentity,
} from "lib/eventTracker";
import {
  goToRelativeRoute,
  DESIGNATION_IDS_MAP,
  openLinkInNewTab,
} from "modules/Services";
import {
  getUserInfofromStorage,
  setUserInfoInStorage,
  setOrgWorkSpaceDetailsInStorage,
  clearOrgWorkSpaceDetailsFromStorage,
  setIsUserLoginActivityLogged,
  clearLocalStorage,
  getJsonItem,
  setJsonItem,
  getIsSentralLoginActivityLogged,
  setIsSentralLoginActivityLogged,
  getSamlInitiatedDetails,
  clearSamlInitiatedDetails,
} from "services/localStorage";
import querystringify from "querystringify";
import { addChild, getWorkrampLoginUrl } from "Courses/modules/CoursesModule";
import {
  handleNavigateWithSessionCheck,
  setAcademicYearSelected,
  setFullScreenLoading,
} from "Platform/modules/PlatformModule";
import {
  ROLE_VISITOR,
  VISITOR,
  TODDLE_LIBRARY,
  CURRICULUM_TYPE_DP,
  SENTRAL,
  FETCH_PLATFORM_URL,
  FETCH_AUTH_CODE_URL,
  LOGGED_OUT_USER_ERROR,
} from "Constants/stringConstants";
import { fetchUserConfigurations } from "ChildrenPage/modules/ChildrenPageModules";
import {
  getPlatformStaffIdentityDetailsFromCache,
  getPlatformUserDetailsFromCache,
} from "modules/CommonGraphqlHelpers";
import { maskInputData } from "@toddle-edu/frontend-utils";
import {
  getSelectedCurriculumProgram,
  getIsStaff,
  getSelectedCurriculumId,
  getUserType,
} from "modules/CommonSelectors";
import {
  getFormattedUserName,
  getUserIdentifierName,
  clearNameSettingCache,
} from "Utils/GetFormattedUserName";
import {
  fetchSentralUserNotificationStateQuery,
  getChildrenQuery,
  getPlatformStaffIdentityDetailsQuery,
  getPlatformUserDetailsQuery,
  getUserDetailsWithLinkedIdentitiesQuery,
  verifySentralOauthRedirectQuery,
} from "modules/CommonQuery";
import { logUserActivityMutation } from "ActivityLogs/modules/ActivityLogMutations";
import {
  addUserImpersonationMutation,
  removeUserImpersonationMutation,
  logoutUserMutation,
} from "../LoginMutation";
import { getConnectionId } from "Utils/Fingerprint";
import {
  updateOrganizationListData,
  setDesignationList,
  authSuperAdminSuccess,
  authUserSuccessAction,
  setIdpsList,
  updateInputField,
  setCurrentScreen,
  setToastMsg,
  setLoginError,
  setLoadingState,
  setActiveTab,
  updateUserInfo,
  updateInvitedFamilyData,
  updateInvitedFamilyChildData,
  updateOrganizationSwitcherDetails,
  setChildData,
  setIdentityPoolDetails,
  setUserIdentityDetails,
  setIdentityScreenFilters,
  setAuthRegion,
  setParentInviteCode,
  setIsUserConfigurationsFetched,
  setGlobalHeaderVisibility,
  _setGlobalHeaderVisibilityOnCurrentRoute,
  setDemoDayVisibility,
  updateSessionVerificationDetails,
  setOrgWorkSpaceDetails,
  clearOrgWorkSpaceDetails,
  logoutUserSuccess,
  setSentralPortalDetails,
  setSsoRequestInitiatedFailed,
  setSamlInitiatedDetails,
  updateMfaVerificationDetails,
} from "./LoginActions";
import {
  initGoogleAnalytics,
  starChatWidget,
  stopChatWidget,
  isUserLoggedOut,
  getCurriculumProgramWithPlansPayload,
  getUserDetailsForStorage,
  getUserInfo,
  getOrgWorkSpaceDetails,
  decodeLocationContext,
  extractDataFromEmailRedirectionUrl,
  isPublicPlatformRoute,
  getIsNewLoginFlowEnabled,
  getIsLoginFlowEnabledV2,
  getLoginDataState,
  checkIsPYPCoordinator,
  getSamlBackendRedirectUrl,
  removeQueryParam,
  hasQueryParam,
  sentralPortalFeatureMapping,
  getDecodedToken,
} from "./LoginUtils";

import { REMOVE_SUPERADMIN_AUTH, OTP_TYPE } from "./LoginConstants";

import { getDesignation } from "Login/components/OrganizationList/OrganizationListUtils";
import { cloudFrontDomain } from "config";
import Microsoft from "lib/microsoft";
import Cookies from "js-cookie";
import WalkMeManager from "lib/walkMe";
import { getIsSentralUrlOpenInNewTabEnabled } from "Utils/ACLStoreUtils";
import { formatErrorMessage } from "Login/components/MultiFactorAuthentication/modules/MultiFactorAuthenticationUtils";

/**
 * Validates the otpVerificationNonce from JWT token against request nonce.
 * @param {string} token - The JWT token containing the nonce
 * @param {string} requestNonce - The nonce to validate against the JWT
 * @returns {object} Validation result with isValid boolean and details
 */
export const validateRequestNonce = ({ token, requestNonce }) => {
  try {
    // Validate input
    if (!token || typeof token !== "string") {
      return {
        isValid: false,
        error: "Invalid Token",
      };
    }

    // Decode the payload
    const payload = getDecodedToken(token);
    // Check if payload is empty
    if (_.isEmpty(payload)) {
      return {
        isValid: false,
        error: "Invalid Token",
      };
    }

    // Extract otpVerificationNonce from JWT payload
    const jwtNonce = _.get(payload, "otpVerificationNonce", null);

    // If jwtNonce is empty or null and requestNonce is not empty, return invalid
    if (!_.isEmpty(requestNonce) && _.isEmpty(jwtNonce)) {
      return {
        isValid: false,
        error: "Invalid Token",
      };
    }

    // Compare the nonces
    if (!_.isEqual(jwtNonce, requestNonce)) {
      return {
        isValid: false,
        error: "Nonce Mismatch",
      };
    }

    return {
      isValid: true,
      error: null,
    };
  } catch (error) {
    return {
      isValid: false,
      error: "Nonce verification failed",
    };
  }
};

// Thunk Helpers

/**
 * This util will start apollo cache persistence in following way:
 * If persistence is not enabled, it will clear data from extenal storage and pause apollo cache persistence
 * If persistence is enabled, it will resume cache persistence and load data in apollo cache
 */
const _setupApolloCachePersistence = () => {
  return async () => {
    try {
      if (window.__IS_CACHE_PERSISTENCE_ENABLED__) {
        persistor.resume();
        await _persistCache();
      } else {
        //eslint-disable-next-line no-console
        console.log("Disabling cache persistance and purging cache");
        persistor.pause();
        await persistor.purge();
      }
    } catch (e) {
      console.error("Error while setting up cache persistance", e);
    }
  };
};

const _persistCache = async () => {
  const apolloClientVersion =
    getJsonItem("__APOLLO_CACHE_VERSION__") ?? window.__APOLLO_CACHE_VERSION__;

  const apolloCacheLastUpdatedAt =
    getJsonItem("apolloCacheLastUpdatedAt") ?? moment().format();

  const isCacheStale =
    moment().diff(moment(apolloCacheLastUpdatedAt), "days") >
    APOLLO_CACHE_PERSISTENCE_EXPITATION_TIME_DURATION_IN_DAYS;

  /**
   * Cached data from the storage will be removed, when
   * 1. Cached data's version is different from the current version of apollo cache.
   * 2. Current version of apollo cache is unset.
   * 3. Cached data is stale (older than 7 days)
   */
  if (
    apolloClientVersion !== window.__APOLLO_CACHE_VERSION__ ||
    _.isEmpty(window.__APOLLO_CACHE_VERSION__) ||
    isCacheStale
  ) {
    //eslint-disable-next-line no-console
    console.log("Purging cache");
    await persistor.purge();
  } else {
    //stopRestoringDataFromIndexedDb will be true when error happens during cache write.
    //In this case, we will not restore cache from indexedDb.
    if (getJsonItem("stopRestoringDataFromIndexedDb") !== true) {
      //eslint-disable-next-line no-console
      console.log("Restoring cache");
      await persistor.restore();
    }
    setJsonItem({ key: "stopRestoringDataFromIndexedDb", value: false });
  }
  setJsonItem({
    key: "__APOLLO_CACHE_VERSION__",
    value: window.__APOLLO_CACHE_VERSION__,
  });
};

// Thunks
export const goToToddleLibraryHome = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const curriculumType = _.get(
      getSelectedCurriculumProgram(state),
      "type",
      ""
    );
    const isDP = curriculumType === CURRICULUM_TYPE_DP;
    let route = "/toddle-library";

    if (isDP) {
      route += "/?source=dpbanner";
    }

    dispatch(
      goToRelativeRoute({
        route,
      })
    );
    dispatch(setActiveTab(TODDLE_LIBRARY));
  };
};

export const goToToddlePlateform = () => {
  return async (dispatch, getState) => {
    dispatch(goToPlatformHomeRoute());
    dispatch(setActiveTab("teacher"));
  };
};

export const updateCurrentScreen = queryParams => {
  return (dispatch, getState) => {
    const { type, usertype, paramsToBeRemoved, role, region } = queryParams;
    let { navigateType } = queryParams;

    const params = _.pick(queryParams, [
      "type",
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_content",
      "utm_term",
      "metadata",
    ]);

    if (!navigateType) {
      navigateType = "push";
    }
    if (usertype) {
      params["usertype"] = usertype;
    }
    if (role) {
      params["role"] = role;
    }

    if (region) {
      params["region"] = region;
    }

    switch (type) {
      case "loginHome":
        navigateType = "replace";
        delete params["usertype"];
        break;

      case "requestSuccess":
        navigateType = "replace";
        delete params["usertype"];
        break;
    }

    dispatch(
      updateQueryParameters({
        params,
        navigateType: navigateType,
        paramsToBeRemoved,
      })
    );
    dispatch(setCurrentScreen(type));
  };
};

export const authUserSuccess = data => {
  return (dispatch, getState) => {
    const user_type = _.get(data, "user_type", "staff");
    const userBrowserDetails = getUserBrowserDetails();
    const userCurriculumPrograms = data?.userCurriculumPrograms ?? [];
    const curriculumPrograms = data?.curriculumPrograms ?? [];

    const orgWorkspaceDetails = getOrgWorkSpaceDetails();

    let organizationId = "";
    if (orgWorkspaceDetails) {
      organizationId = orgWorkspaceDetails.organizationId;
    }

    const curriculumProgramWithPlansPayload = getCurriculumProgramWithPlansPayload(
      { userCurriculumPrograms, curriculumPrograms }
    );

    if (data.shouldInitThirdParty) {
      if (data.org_id && data.organization_id == null) {
        // To only start chat when authUserSuccess is called after graphql call

        //Reading permissions from ACLStore
        const isSentryEnabled = !ACLStore.can("disableSentry");
        const isMixPanelEnabled = !ACLStore.can("disableMixPanel");
        const isIntercomEnabled = !ACLStore.can("disableIntercom");
        const isAblyEnabled = !ACLStore.can("disableAbly");
        const isGoogleAnalyticsEnabled = !ACLStore.can(
          "disableGoogleAnalytics"
        );

        //Sentry
        if (isSentryEnabled) {
          Sentry.configureScope(scope => {
            scope.setUser(
              maskInputData({
                input: {
                  id: data.id,
                  email: data.email,
                  first_name: data.first_name,
                  last_name: data.last_name,
                  org_id: data.org_id,
                  org_name: data.org_name,
                  /**
                   * @deprecated
                   */
                  orgPlan: data.orgPlan,
                  designation: data.designation,
                  user_type: data.user_type,
                  ...curriculumProgramWithPlansPayload,
                },
              })
            );
            scope.setTag("org_id", data.org_id);
            scope.setTag("user_type", data.user_type);
          });
        }

        //MixPanel
        if (isMixPanelEnabled && (user_type == "staff" || organizationId)) {
          initMixPanel();
          identifyUser({ identityString: data.email });
          /**
           * @deprecated
           */
          recordTrait({
            data: {
              uid: data.id,
              fname: data.first_name,
              lname: data.last_name,
              email: data.email,
              user_type: "user",
              role: data.designation,
              org_id: data.org_id,
              org_name: data.org_name,
              org_plan: data.orgPlan,
              ...curriculumProgramWithPlansPayload,
            },
          });
          setOrganization({ data });

          if (organizationId) {
            recordEvent({
              eventName: "Organization Scoped Logged In",
            });
          } else {
            recordEvent({ eventName: "Logged In" });
          }
        } else {
          window.mixpanel = null;
          window._kmq = null;
        }

        //Intercom
        if (
          isIntercomEnabled &&
          ACLStore.can(ENABLE_INTERCOM_CONSUMPTION) &&
          user_type == "staff"
        ) {
          stopChatWidget(); //Terminate session
          starChatWidget({
            intercom_user_jwt: data?.intercom_user_jwt,
            ...curriculumProgramWithPlansPayload,
            Is_IB_Evaluator: ACLStore.can(SNPv2_VISITOR_PORTAL_PERM_GROUP),
          });
        } else {
          stopChatWidget();
        }

        //Ably
        if (isAblyEnabled) {
          setPusherConnection(data.id);
        }

        //Google Analytics
        if (isGoogleAnalyticsEnabled && user_type != "student") {
          initGoogleAnalytics();
          setGA({ userId: data.id, dimension1: user_type });

          // window[`ga-disable-${GOOGLE_ANALYTICS_ID}`] = !isSettingEnabled({
          //   settings,
          //   settingName: "disableGoogleAnalytics"
          // });
        }
      }
    }
    dispatch(
      authUserSuccessAction({
        ...(data || {}),
        userLoggedIn: _.get(getState(), "login.userLoggedIn"),
      })
    );
  };
};

/**
 * __FamilyPortal__
 * Below function extract's necessary data
 * then updates redux store
 * then updates local storage
 */
export const switchChild = ({ childData }) => {
  return (dispatch, getState) => {
    // reset academic year

    const firstName = _.get(childData, "firstName", "");
    const middleName = _.get(childData, "middleName", "");
    const lastName = _.get(childData, "lastName", "");
    const pronouns = _.get(childData, "pronouns", "");
    const preferredName = _.get(childData, "preferredName", "");
    const suffix = _.get(childData, "suffix", "");
    const childID = _.get(childData, "id", "");
    const childProfileImage = _.get(childData, "profileImage", "");
    const jwt = _.get(childData, "jwt", "");
    const org_id = _.get(childData, "organization.id", "");
    const org_name = _.get(childData, "organization.name", "");
    const orgIsFree = _.get(childData, "organization.tier.isFree", "");
    const allCourses = _.get(childData, "allCourses", []);
    const isChildBlocked = _.get(childData, "isBlocked", false);
    const childBlockedMessage = _.get(childData, "blockMessage", "");
    const childName = `${firstName} ${lastName}`;
    const childFormattedName = getFormattedUserName({ user: childData });
    const childIdentifierName = getUserIdentifierName({ user: childData });

    const childDataObj = {
      jwt,
      org_id,
      //TODO: remove this field when curriculum program subscription plan is enabled
      orgIsFree,
      childName,
      childID,
      childProfileImage,
      token: jwt,
      isChildBlocked,
      childBlockedMessage,
    };

    // update redux store
    dispatch(
      setChildData({
        ...childDataObj,
        org_name,
        childFirstName: firstName,
      })
    );

    // manage local storage
    const userInfo = getUserInfo();

    const newStorageData = {
      ...userInfo,
      ...childDataObj,
      org_name,
      childFormattedName,
      childIdentifierName,
      childFirstName: firstName,
      childMiddleName: middleName,
      childLastName: lastName,
      childPronouns: pronouns,
      childPreferredName: preferredName,
      childSuffix: suffix,
    };

    dispatch(setUserInfoInReduxAndStorage(newStorageData));
    dispatch(handleAcademicYearForParent());
    // clear memoized values for name setting
    clearNameSettingCache();
  };
};

/**
 * This function is wrapper for switchChild.
 * use this if switch child based on studentId
 * studentId is the id of child that you want to switch and not current active childId
 */

export const handleAcademicYearForParent = () => {
  return async (dispatch, getState) => {
    // reset academic year (latest academic year will be set in Platform.js)
    dispatch(
      setAcademicYearSelected({
        id: null,
        startDate: null,
        endDate: null,
        isCurrentAcademicYear: true,
        showPreviousYearMsg: true,
      })
    );
  };
};

export const setUserInfoInReduxAndStorage = userInfo => {
  return async dispatch => {
    setUserInfoInStorage(userInfo);
    dispatch(updateUserInfo(userInfo));
  };
};

export const setOrgWorkSpaceDetailsInReduxAndStorage = data => {
  return async dispatch => {
    setOrgWorkSpaceDetailsInStorage(data);
    dispatch(setOrgWorkSpaceDetails(data));
  };
};

export const resetOrgWorkSpaceDetails = () => {
  return async dispatch => {
    clearOrgWorkSpaceDetailsFromStorage();
    dispatch(clearOrgWorkSpaceDetails());
  };
};

export const setUserInfo = ({
  staffDetails,
  organization,
  portalType,
  shouldSaveInLocalStorage,
  userCurriculumPrograms,
  shouldSaveInRedux,
  projectGroups,
  idpCode,
}) => {
  return async (dispatch, getState) => {
    const userLoggedIn =
      (getState().login.userLoggedIn || !_.isEmpty(staffDetails)) &&
      _.get(staffDetails, "id") != _.get(DUMMY_USER_INFO, "id") &&
      _.get(staffDetails, "id") != _.get(PUBLIC_USER_INFO_EU_WEST_1, "id") &&
      _.get(staffDetails, "id") != _.get(PUBLIC_USER_INFO_US_EAST_1, "id");

    let userParams = getUserDetailsForStorage({
      staffDetails,
      organization,
    });

    // __FamilyPortal__ - childID will be present only when FamilyMember is LoggedIn
    const childID = _.get(staffDetails, "childID", "");
    if (childID) {
      /** __FamilyPortal__
       * In family portal 2 jwt are stored
       * 1. parentToken: jwt of parent
       * 2. token: jwt of child
       * */
      const childName = _.get(staffDetails, "childName", "");
      const childProfileImage = _.get(staffDetails, "childProfileImage", "");
      const parentToken = _.get(staffDetails, "parentToken", null);
      userParams = {
        ...userParams,
        childID,
        childName,
        childProfileImage,
        parentToken,
      };
    }
    const curriculumPrograms = _.get(organization, "curriculumPrograms", []);

    const extraData = {
      org_name: _.get(organization, "name", ""),
      orgRegion: _.get(organization, "region", ""),
      //TODO: remove this field when curriculum program subscription plan is enabled
      orgPlan: _.get(organization, "tier.plan", ""),
      childFirstName: _.get(staffDetails, "childFirstName", ""),
      childMiddleName: _.get(staffDetails, "childMiddleName", ""),
      childLastName: _.get(staffDetails, "childLastName", ""),
      childPronouns: _.get(staffDetails, "childPronouns", ""),
      childPreferredName: _.get(staffDetails, "childPreferredName", ""),
      childPrefix: _.get(staffDetails, "childPrefix", ""),
      childSuffix: _.get(staffDetails, "childSuffix", ""),
      childIdentifierName: _.get(staffDetails, "childIdentifierName", ""),
      childFormattedName: _.get(staffDetails, "childFormattedName", ""),
      isChildBlocked: _.get(staffDetails, "isChildBlocked", false),
      childBlockedMessage: _.get(staffDetails, "childBlockedMessage", ""),
      role: _.get(staffDetails, "role", null),
      tags: _.get(staffDetails, "entityTags", []),
      //TODO: remove this field when curriculum program subscription plan is enabled
      orgIsFree: _.get(organization, "tier.isFree", false),
      personalProjectId: _.get(organization, "personalProject.id", ""),
      communityProjectId: _.get(organization, "communityProject.id", ""),
      serviceAsActionId: _.get(organization, "serviceAsAction.id", ""),
      userCurriculumPrograms,
      portalType,
      shouldInitThirdParty: shouldSaveInLocalStorage,
      userLoggedIn,
      curriculumPrograms,
      projectGroups,
      phoneNumber: _.get(staffDetails, "phoneNumber", ""),
      userDetailsHash: _.get(staffDetails, "userDetailsHash", []),
      idpCode,
    };

    if (shouldSaveInRedux && userLoggedIn) {
      dispatch(
        setUserIdentityDetails(
          _.map(staffDetails.userIdentityDetails, detail => {
            const { linkedUser: user, portalType } = detail || {};
            return {
              ...getUserDetailsForStorage({
                staffDetails: user,
                organization: _.get(user, "organization", {}),
              }),
              portalType,
            };
          })
        )
      );
    }

    if (shouldSaveInLocalStorage) {
      const isMixPanelEnabled = !ACLStore.can("disableMixPanel");

      const userStorageParams = {
        id: staffDetails.id,
        ...userParams,
        portalType,
        enabledMixPanel: isMixPanelEnabled,
        role: _.get(staffDetails, "role", null),
        tags: _.get(staffDetails, "entityTags", []),
        ...extraData,
      };
      if (userLoggedIn) {
        dispatch(setUserInfoInReduxAndStorage(userStorageParams));
      }
    }

    dispatch(
      authUserSuccess({
        ...userParams,
        ...extraData,
      })
    );
  };
};

const switchOrganization = async (dispatch, queryVariables) => {
  const linkedIdentities = await client.query({
    query: getUserDetailsWithLinkedIdentitiesQuery,
    variables: queryVariables,
    fetchPolicy: "network-only",
  });
  const linkedIdentitiesEdges = _.get(
    linkedIdentities,
    "data.node.linkedIdentityUsersV2.edgesV2",
    []
  );

  const linkedIdentity = _.first(
    _.map(linkedIdentitiesEdges, ({ node }) => {
      const { designation, type } = node;

      const finalDesignation = getDesignation({
        userType: type,
        designation,
        t: params => params, // no need to pass actual t function as we are not using it
      });

      return {
        ...node,
        designation: finalDesignation,
      };
    })
  );
  dispatch(onSelectOrganization({ ...linkedIdentity, emailSource: true }));
};

export const checkAuthentication = (params = {}) => {
  return async (dispatch, getState) => {
    const isUserLoggedIn = !isUserLoggedOut();

    if (isUserLoggedIn) {
      const redirectionUrlParams = decodeLocationContext(window.location.href);
      dispatch(setCurrentUser(params));
      const userInfo = getUserInfofromStorage();
      // this code will execute only for staff and window.location.href query params has source email
      if (
        redirectionUrlParams &&
        isUserTypeStaff({ userType: userInfo?.user_type })
      ) {
        const queryVariables = {
          id: userInfo?.id,
          type: userInfo?.userEntityType,
          searchText: redirectionUrlParams?.metadata?.orgId || "",
          first: 1,
        };
        await switchOrganization(dispatch, queryVariables);
      }
    } else {
      await dispatch(setLoadingState(false));
    }
  };
};

/**It will update current user according to params.
 * params contain new user's id
 */
export const setCurrentUser = (params = {}) => {
  return async dispatch => {
    const userInfo = getUserInfofromStorage();
    const currentUserId = userInfo.id;
    /**If there is no params,continue with current user authentication */
    if (_.isEmpty(params)) {
      await dispatch(_onUserAuthentication(userInfo));
    } else {
      const incomingUserId = params.id ?? "";
      /**If current user's id is same as new user's id
       * then continue with current user authentication.
       */
      if (currentUserId === incomingUserId) {
        await dispatch(_onUserAuthentication(userInfo));
      } else {
        /**If both are different, means current user has multiple identities.
         * So, authenticate via organization switcher
         */
        dispatch(
          authenticateUserWithMultipleIdentities({
            data: { id: currentUserId },
            hasUserLoggedOut: false,
            userParams: {
              userEntityType: userInfo.userEntityType,
            },
          })
        );
      }
    }
  };
};

export const handleApiError = ({ error }) => {
  return async (dispatch, getState) => {
    console.error(error);
    dispatch(setLoadingState(false));
    if (!error.response) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    } else {
      const msg = _.get(
        error,
        "response.data.errors.0.message",
        "toastMsgs:something_went_wrong"
      );
      const status = _.get(error, "response.status", 400);

      if (status === 429) {
        dispatch(setToastMsg("toastMsgs:rate_limit_error_msg"));

        return;
      }
      switch (msg) {
        case "URL_TOKEN_INVALID_OR_EXPIRED":
          dispatch(setLoginError(msg));
          break;
        case "INVALID_AUTH_CODE":
          dispatch(
            setToastMsg({
              msg: formatErrorMessage(msg),
              type: "error",
            })
          );
          break;
        default:
          dispatch(
            setToastMsg({
              msg,
              notString: true,
            })
          );
      }
    }
  };
};

export const makeApiRequest = ({ url, requestObj }) => {
  return async (dispatch, getState) => {
    try {
      dispatch(setLoadingState(true));
      return await axios.post(
        getBackendServerUrl({
          path: url,
        }),
        requestObj,
        {
          headers: {
            "x-tod-connection-id": await getConnectionId(),
          },
        }
      );
    } catch (error) {
      dispatch(handleApiError({ error }));
    } finally {
      dispatch(setLoadingState(false));
    }
  };
};

export const getDesignationList = () => {
  return async (dispatch, getState) => {
    dispatch(setLoadingState(true));

    try {
      const response = await axios.get(
        getBackendServerUrl({
          path: "/auth/getDesignations",
        })
      );
      const data = _.get(response, "data", {});
      const designationList = _.map(data, designation => {
        const { id, title, description } = designation;
        return {
          ...designation,
          label: title,
          value: id,
          subText: description,
        };
      });
      dispatch(setDesignationList(designationList));
    } catch (error) {
      dispatch(handleApiError({ error }));
    } finally {
      dispatch(setLoadingState(false));
    }
  };
};

export const getOrganizationList = () => {
  return async (dispatch, getState) => {
    const {
      edges = [],
      pageInfo: { endCursor } = {},
      searchText,
      lastSearchText,
    } = _.get(getState().login, "organizationListData", {});
    dispatch(
      updateOrganizationListData({
        isLoading: true,
      })
    );

    const isLastSearchMatch = _.isEqual(lastSearchText, searchText);
    const after = isLastSearchMatch ? endCursor : "";
    try {
      const requestObj = {
        first: 10,
        after,
        searchText,
      };
      const response = await axios.post(
        getBackendServerUrl({
          path: "/auth/fetchListedOrganizations",
        }),
        requestObj
      );
      const data = _.get(response, "data", {});
      let newEdges = _.get(data, "edges", []);
      if (after) {
        newEdges = _.uniqBy([...edges, ...newEdges], "node.id");
      }

      dispatch(
        updateOrganizationListData({
          ...data,
          edges: newEdges,
          isLoading: false,
          lastSearchText: searchText,
        })
      );
    } catch (error) {
      dispatch(handleApiError({ error }));
    }
  };
};

export const verifyDomain = ({ email } = {}) => {
  return async (dispatch, getState) => {
    try {
      const { selectedSchool: { id: listedOrganizationId } = {} } = _.get(
        getState().login,
        "formData.organizationSelection",
        {}
      );

      const requestObj = {
        email,
        listedOrganizationId,
      };
      const response = await axios.post(
        getBackendServerUrl({
          path: "/auth/v2/signUp/verifyDomain",
        }),
        requestObj,
        {
          headers: {
            "x-tod-connection-id": await getConnectionId(),
          },
        }
      );
      const data = _.get(response, "data", {});
      const oldData = _.get(getState().login, "formData.createAccount", {});

      dispatch(updateInputField("createAccount", { ...oldData, ...data }));
    } catch (error) {
      dispatch(handleApiError({ error }));
    }
  };
};

export const fetchInvitedUserByToken = ({ token } = {}) => {
  return async (dispatch, getState) => {
    try {
      const requestObj = {
        token,
      };
      const response = await axios.post(
        getBackendServerUrl({
          path: "/auth/v2/signUp/fetchInvitedUserByToken",
        }),
        requestObj,
        {
          headers: {
            "x-tod-connection-id": await getConnectionId(),
          },
        }
      );
      const data = _.get(response, "data", {});
      dispatch(
        updateInputField("organizationSelection", {
          selectedSchool: {
            name: _.get(data, "organizationName", ""),
            id: _.get(data, "organizationId", ""),
          },
        })
      );
      dispatch(updateInputField("createAccount", {}));
      dispatch(updateInputField("createAccount", { ...data, token }));
      dispatch(updateCurrentScreen({ type: "createAccount" }));
    } catch (error) {
      dispatch(handleApiError({ error }));
    }
  };
};

export const fetchInvitedParentByToken = ({
  token,
  inviteCode,
  isV3FlowEnabled = false,
} = {}) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const requestObj = {
        token,
        userType: "parent",
        region: _.get(state, "login.authRegion", null),
        isV3FlowEnabled,
        ...(isV3FlowEnabled ? {} : { inviteCode }),
      };
      const response = await axios.post(
        getBackendServerUrl({
          path: "/auth/v3/signUp/fetchInvitedUserByToken",
        }),
        requestObj,
        {
          headers: {
            "x-tod-connection-id": await getConnectionId(),
          },
        }
      );
      const data = _.get(response, "data", {});
      if (!_.isEmpty(data.login_token)) {
        dispatch(
          familyInviteTokenSignIn({
            login_token: data.login_token,
            shouldCallAddChild: false,
          })
        );
      } else {
        dispatch(updateInputField("createParentAccount", {}));
        dispatch(updateInputField("createParentAccount", data));
        dispatch(updateCurrentScreen({ type: "createParentAccount" }));
      }
    } catch (error) {
      dispatch(handleApiError({ error }));
    }
  };
};

export const navigateToCreateParent = data => {
  return async (dispatch, _) => {
    dispatch(updateInputField("createParentAccount", {}));
    dispatch(updateInputField("createParentAccount", data));
    dispatch(updateCurrentScreen({ type: "createParentAccount" }));
  };
};

export const verifyClassInviteLinkAndNavigateToCreateParent = ({ link }) => {
  return async (dispatch, getState) => {
    const response = await dispatch(verifyClassInviteLink(link));
    const userLoggedIn = _.get(getState(), "login.userLoggedIn");
    const invitedFamiyData = _.get(getState(), "login.invitedFamilyData");

    if (response) {
      // Check code param, if we are using shorten class invite url
      if (
        !_.isEmpty(_.get(invitedFamiyData, "code", "")) &&
        !_.isEmpty(_.get(response, "data.link", ""))
      ) {
        const link = _.get(response, "data.link", "");

        const urlObj = new URL(link);
        const params = new URLSearchParams(urlObj.search);

        const metadata = JSON.parse(decodeURIComponent(params.get("metadata")));
        const type = params.get("type");
        const region = params.get("region");
        const usertype = params.get("usertype");

        const invitedFamilyUpdatedData = {
          metadata,
          type,
          region,
          usertype,
        };

        dispatch(
          updateQueryParameters({
            params: {
              usertype,
              region,
            },
          })
        );

        dispatch(
          updateInvitedFamilyData({
            ...invitedFamilyUpdatedData,
            verified: true,
          })
        );
      } else {
        dispatch(
          updateInvitedFamilyData({ ...invitedFamiyData, verified: true })
        );
      }
      dispatch(navigateToCreateParent({}));
    } else {
      dispatch(updateInvitedFamilyData({}));

      userLoggedIn
        ? dispatch(goToRelativeRoute({ route: "/", type: "replace" }))
        : dispatch(
            updateCurrentScreen({
              type: "loginHome",
              paramsToBeRemoved: ["metadata"],
            })
          );
    }
  };
};

export const verifyClassInviteLink = link => {
  return async (dispatch, getState) => {
    const url = "/auth/verifyClassInviteLink";

    const requestObj = {
      inviteLink: link,
      region: _.get(getState(), "login.authRegion", null),
    };

    const response = await dispatch(makeApiRequest({ url, requestObj }));
    return response;
  };
};

export const familyInviteTokenSignIn = ({
  login_token,
  isClassInvite = false,
  shouldCallAddChild = true,
}) => {
  return async (dispatch, getState) => {
    const res = await dispatch(
      authenticateUserWithServer({
        idToken: login_token,
        method: "url",
        userType: "parent",
      })
    );
    if (!isClassInvite && shouldCallAddChild) {
      dispatch(addChildFromInvitedData());
    } else if (!shouldCallAddChild) {
      dispatch(updateInvitedFamilyData({}));
    } else {
      dispatch(updateInvitedFamilyChildData({}));
    }
  };
};

export const handleVerifyParentInviteCode = () => {
  return async (dispatch, getState) => {
    const { inviteCode } = _.get(
      getState().login,
      "formData.verifyParentInviteCode",
      {}
    );

    const orgWorkspaceDetails = getOrgWorkSpaceDetails();

    let organizationId = "";
    if (orgWorkspaceDetails) {
      organizationId = orgWorkspaceDetails.organizationId;
    }

    const requestObj = {
      inviteCode,
      orgId: organizationId,
    };

    const url = "/auth/verifyParentInviteCode";
    const response = await dispatch(makeApiRequest({ url, requestObj }));

    const isSuccess = _.get(response, "data.isSuccess", false);
    const region = _.get(response, "data.region");

    if (isSuccess) {
      dispatch(setAuthRegion(region));
      dispatch(setParentInviteCode(inviteCode));
      dispatch(updateCurrentScreen({ type: "createParentAccount" }));
    } else {
      const msg = _.get(response, "data.message", "");
      if (msg) {
        dispatch(
          setToastMsg({
            msg,
            notString: true,
          })
        );
      }
    }
  };
};

// this function is called for normal signup flow and for class invite flow
export const handleCreateParentAccount = () => {
  return async (dispatch, getState) => {
    const { email } = _.get(
      getState().login,
      "formData.createParentAccount",
      {}
    );

    // region will be present in normal signup flow and for class invite flow
    const region = _.get(getState(), "login.authRegion", null);

    // parentInviteCode will be present if user has navigated through normal signup flow
    const parentInviteCode = _.get(getState(), "login.parentInviteCode", null);

    const requestObj = {
      email,
      userType: "parent",
    };

    if (region) {
      // if region is sent, then it will add verification code in the table(user_email_verify_code) of passed region
      requestObj["region"] = region;
    }

    if (parentInviteCode) {
      // consider scenario where parent is invited from via email
      // Now, if parent is doing normal signup flow with the email which is already invited by parent
      // In that case, below parentInviteCode will help to get the region of student. And it can be verified that parent and student are in same region or not
      requestObj["parentInviteCode"] = parentInviteCode;
    }

    const url = "/auth/v2/generateEmailVerificationCode";
    const response = await dispatch(
      makeApiRequest({
        url,
        requestObj,
      })
    );
    const isSuccess = _.get(response, "data.isSuccess", false);
    if (isSuccess) {
      dispatch(
        updateInputField("verifyOTP", {
          email,
          otp: "",
        })
      );
      dispatch(updateCurrentScreen({ type: "verifyOTP" }));
    } else {
      const msg = _.get(response, "data.message", "");
      dispatch(
        setToastMsg({
          msg,
          notString: true,
        })
      );
    }
  };
};

const generateOTP = requestObj => {
  return async dispatch => {
    const url = "/auth/v2/mobileUserOTPGenerate";
    const response = await dispatch(
      makeApiRequest({
        url,
        requestObj,
      })
    );
    const isSuccess = _.get(response, "data.isSuccess", false);
    const RESEND_TIMER = parseInt(
      _.get(response, "data.regenOTPTime", 30000) / 1000
    );
    return { isSuccess, RESEND_TIMER };
  };
};

const generateEmailOTP = requestObj => {
  return async dispatch => {
    const url = "/auth/v2/generateOTP";
    const response = await dispatch(makeApiRequest({ url, requestObj }));
    const isSuccess = _.get(response, "data.isSuccess", false);
    const RESEND_TIMER = _.ceil(
      _.get(response, "data.regenOTPTime", 15000) / 1000
    );
    return { isSuccess, RESEND_TIMER };
  };
};

const verifyOTP = requestObj => {
  return async dispatch => {
    const url = "/auth/v2/mobileUserOTPAuthenticate";
    const response = await dispatch(makeApiRequest({ url, requestObj }));
    const isSuccess = _.get(response, "data", false);
    return isSuccess;
  };
};

export const generateOtpForSignIn = () => {
  return async (dispatch, getState) => {
    const { phoneNo } = _.get(
      getState().login,
      getIsNewLoginFlowEnabled({ userType: "parent" })
        ? "formData.parentLogin"
        : "formData.loginWithPhoneOTP",
      {}
    );
    const requestObj = {
      phoneNumber: `+${phoneNo}`,
      userType: "parent",
      callType: "SignIn",
    };

    const { isSuccess, RESEND_TIMER } = await dispatch(generateOTP(requestObj));

    if (isSuccess) {
      dispatch(
        setToastMsg({
          msg: `toastMsgs:sent_successfully`,
          type: "success",
        })
      );
      getIsLoginFlowEnabledV2({ userType: "parent" })
        ? dispatch(
            updateInputField("loginFormV3", { resendTimer: RESEND_TIMER })
          )
        : dispatch(updateInputField("loginFormV2", { RESEND_TIMER }));
    }
    return { isSuccess };
  };
};

export const verifyParentOTPForSignIn = () => {
  return async (dispatch, getState) => {
    const { phoneNo, otp } = _.get(
      getState().login,
      getIsNewLoginFlowEnabled({ userType: "parent" })
        ? "formData.loginFormV2"
        : "formData.loginWithPhoneOTP",
      {}
    );

    const requestObj = {
      phoneNumber: `+${phoneNo}`,
      OTP: otp,
    };

    const isSuccess = await dispatch(verifyOTP(requestObj));

    if (isSuccess) {
      dispatch(
        authenticateUserWithServer({
          method: "local",
          userType: "parent",
          isPhoneSignIn: true,
        })
      );
    } else {
      dispatch(updateInputField("loginWithPhoneOTP", { otp: "" }));
    }
  };
};

export const generateEmailOTPForSignIn = props => {
  return async (dispatch, getState) => {
    const {
      userType,
      role,
      email = _.get(
        getState().login.formData,
        `${getLoginDataState({ userType, role })}.email`,
        ""
      ),
    } = props;

    const requestObj = {
      email,
      userType,
      otpType: OTP_TYPE.EMAIL_LOGIN,
    };

    const { isSuccess, RESEND_TIMER } = await dispatch(
      generateEmailOTP(requestObj)
    );

    if (isSuccess) {
      if (RESEND_TIMER < 15) {
        dispatch(
          setToastMsg({
            msg: `toastMsgs:request_otp_after_timer`,
            type: "warning",
            locale_params: [
              {
                key: "timer",
                value: RESEND_TIMER,
                isPlainText: true,
              },
            ],
            notString: true,
          })
        );
      } else {
        dispatch(
          setToastMsg({
            msg: `toastMsgs:otp_sent_to_verified_email`,
            type: "success",
          })
        );
      }

      getIsLoginFlowEnabledV2({ userType })
        ? dispatch(
            updateInputField("loginFormV3", { resendTimer: RESEND_TIMER })
          )
        : dispatch(updateInputField("loginFormV2", { RESEND_TIMER }));
    }

    return { isSuccess };
  };
};

// Generate OTP for password reset
export const generateOTPForParent = ({
  showMessage = false,
  isPhone = false,
  callback,
} = {}) => {
  return async (dispatch, getState) => {
    // showMessage will be true when Resend button is clicked
    // isPhone will be true, if forgot password cycle is invoked for Phone Login
    if (isPhone) {
      const { phoneNo } = _.get(
        getState().login,
        "formData.forgotPhonePassword",
        {}
      );

      dispatch(
        updateInputField("verifyPhoneOTP", {
          phoneNo,
          otp: "",
        })
      );

      const requestObj = {
        phoneNumber: `+${phoneNo}`,
        userType: "parent",
        callType: "RegeneratePassword",
      };

      const isSuccess = await dispatch(generateOTP(requestObj));

      if (isSuccess && showMessage) {
        dispatch(
          setToastMsg({
            msg: `toastMsgs:sent_successfully`,
            type: "success",
          })
        );
      } else if (isSuccess) {
        dispatch(updateCurrentScreen({ type: "verifyPhoneOTP" }));
      }
    } else {
      const { email } = _.get(
        getState().login,
        "formData.createParentAccount",
        {}
      );

      const requestObj = {
        email,
        userType: "parent",
        region: _.get(getState(), "login.authRegion", null),
        parentInviteCode: _.get(getState(), "login.parentInviteCode", null),
      };

      // this api is called whenever parent clicks on Resend Code button
      const url = "/auth/v2/generateEmailVerificationCode";
      const response = await dispatch(makeApiRequest({ url, requestObj }));
      const isSuccess = _.get(response, "data.isSuccess", false);
      if (isSuccess) {
        if (showMessage) {
          dispatch(
            setToastMsg({
              msg: `toastMsgs:sent_successfully`,
              type: "success",
            })
          );
        }
        if (_.isFunction(callback)) {
          const resendTimerDuration = _.ceil(
            _.get(response, "data.regenOTPTime", 15000) / 1000
          );
          callback({ isSuccess: true, resendTimerDuration });
        }
      }
    }
  };
};

// Used for verification of OTP and reset the password
export const verifyParentOTP = ({ isPhone = false } = {}) => {
  return async (dispatch, getState) => {
    // isPhone will be true, if forgot password cycle is invoked for Phone Login
    if (isPhone) {
      const { phoneNo, otp } = _.get(
        getState().login,
        "formData.verifyPhoneOTP",
        {}
      );

      const requestObj = {
        phoneNumber: `+${phoneNo}`,
        OTP: otp,
      };

      const isSuccess = await dispatch(verifyOTP(requestObj));

      if (isSuccess) {
        dispatch(updateCurrentScreen({ type: "resetPassword" }));
        dispatch(
          updateInputField("resetPassword", {
            phoneNo,
            otp,
          })
        );
      }
    } else {
      // v3 atomic sign-up: OTP verification + user creation in a single call
      dispatch(handleParentSignUp());
    }
  };
};

export const handleParentSignUp = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const { firstName, middleName, lastName, email } = _.get(
      state.login,
      "formData.createParentAccount",
      {}
    );

    // region will be present if user has navigated through class invite link
    const region = _.get(state, "login.authRegion", null);

    // parentInviteCode will be present if user has navigated through normal signup flow
    const parentInviteCode = _.get(state, "login.parentInviteCode", null);
    const { otp } = _.get(state, "login.formData.verifyOTP", {});
    const requestNonce = generateRandomNonce(12, "base64");

    const requestObj = {
      userDetails: {
        firstName,
        middleName,
        lastName,
        email,
      },
      userType: "parent",
      method: "local",
      code: otp,
      otpVerificationNonce: requestNonce,
    };

    if (region) {
      // if region is sent then it will create parent account in that region
      requestObj["region"] = region;
    }

    if (parentInviteCode) {
      // if student's parentInviteCode is sent in api, then it will add student to the parent
      requestObj["parentInviteCode"] = parentInviteCode;
    }

    const url = "/auth/v3/signUp";
    const response = await dispatch(makeApiRequest({ url, requestObj }));
    if (response?.status == "200") {
      const verificationToken = _.get(response, "data.token", null);
      const validateNonce = validateRequestNonce({
        token: verificationToken,
        requestNonce,
      });
      if (!_.get(validateNonce, "isValid")) {
        dispatch(setToastMsg("toastMsgs:request_verification_failed"));
        return;
      }
      dispatch(validateUser({ ...response.data, identityUserType: "parent" }));
      dispatch(setParentInviteCode(null));
    } else {
      dispatch(setToastMsg("toastMsgs:invalid_otp"));
    }
  };
};

export const generateOTPForUnauthenticatedUser = ({
  showMessage = false,
} = {}) => {
  return async (dispatch, getState) => {
    const { id } = _.get(getState().login, "formData.verifyOTP", {});
    try {
      const requestObj = {
        id,
      };
      dispatch(setLoadingState(true));
      const response = await axios.post(
        getBackendServerUrl({
          path: "/auth/signUp/generateOTPForUnauthenticatedUser",
        }),
        requestObj,
        {
          headers: {
            "x-tod-connection-id": await getConnectionId(),
          },
        }
      );
      const isSuccess = _.get(response, "data", false);
      dispatch(setLoadingState(false));
      if (isSuccess && showMessage) {
        dispatch(
          setToastMsg({
            msg: `toastMsgs:sent_successfully`,
            type: "success",
          })
        );
      }
      console.error(response);
    } catch (error) {
      dispatch(handleApiError({ error }));
    }
  };
};

export const verifyUnauthenticatedUserOTP = () => {
  return async (dispatch, getState) => {
    const { id, otp, pypCoordinatorId } = _.get(
      getState().login,
      "formData.verifyOTP",
      {}
    );
    const { weburl = "", url = "" } = _.get(
      getState().login,
      "formData.addIdentification",
      {}
    );

    try {
      const requestNonce = generateRandomNonce(12, "base64");
      const requestObj = {
        id,
        otp,
        weburl,
        url,
        pypCoordinatorId,
        otpVerificationNonce: requestNonce,
      };
      dispatch(setLoadingState(true));
      const response = await axios.post(
        getBackendServerUrl({
          path: "/auth/signUp/verifyUnauthenticatedUserOTP",
        }),
        requestObj
      );
      dispatch(setLoadingState(false));
      const data = _.get(response, "data", {});

      if (_.get(data, "data.isSuccess", false)) {
        const { email: userEmail, firstName } = _.get(
          getState().login,
          "formData.createAccount",
          {}
        );
        aliasUser({ identityString: userEmail });

        const state = _.get(data, "data.state", false);
        const isDomainValid = _.get(data, "data.isDomainValid", false);
        if (state == "REQ_ACC_NO_ORG" || state == "REQ_ACC_HS_ORG") {
          dispatch(
            updateInputField("requestSuccess", {
              status: state,
              isDomainValid,
              firstName,
            })
          );
          dispatch(updateCurrentScreen({ type: "requestSuccess" }));
        } else if (state == "USR_CRTD") {
          const validateNonce = validateRequestNonce({
            token: response.data.token,
            requestNonce,
          });
          if (!_.get(validateNonce, "isValid")) {
            dispatch(setToastMsg("toastMsgs:request_verification_failed"));
            return false;
          }

          dispatch(
            validateUser({
              ...response.data,
              identityUserType: "staff",
            })
          );
        } else {
          dispatch(setToastMsg("toastMsgs:something_went_wrong"));
        }
      } else {
        dispatch(setToastMsg("toastMsgs:invalid_otp"));
      }
    } catch (error) {
      dispatch(handleApiError({ error }));
    }
  };
};

export const createPYPCoordinator = () => {
  return async (dispatch, getState) => {
    const { id, email, firstName, lastName } = _.get(
      getState().login,
      "formData.addPYPDetails",
      {}
    );
    const { selectedSchool: { id: listedOrganizationId } = {} } = _.get(
      getState().login,
      "formData.organizationSelection",
      {}
    );
    try {
      const requestObj = {
        id,
        listedOrganizationId,
        email,
        firstName,
        lastName,
      };
      dispatch(setLoadingState(true));
      const response = await axios.post(
        getBackendServerUrl({
          path: "/auth/signUp/createPYPCoordinator",
        }),
        requestObj
      );
      const data = _.get(response, "data", {});
      dispatch(
        updateInputField("verifyOTP", {
          pypCoordinatorId: data.id,
          otp: "",
        })
      );

      dispatch(updateCurrentScreen({ type: "verifyOTP" }));
      dispatch(setLoadingState(false));
    } catch (error) {
      dispatch(handleApiError({ error }));
    }
  };
};

export const createInvitedUser = () => {
  return async (dispatch, getState) => {
    try {
      const { selectedSchool: { id: listedOrganizationId } = {} } = _.get(
        getState().login,
        "formData.organizationSelection",
        {}
      );
      const {
        firstName,
        lastName,
        email,
        role,
        designation,
        password,
        stateCode,
        token,
      } = _.get(getState().login, "formData.createAccount", {});
      //console.log(stateCode);
      const requestObj = {
        firstName,
        lastName,
        email,
        role,
        designation,
        password,
        organizationId: listedOrganizationId,
        token,
      };
      dispatch(setLoadingState(true));
      const response = await axios.post(
        getBackendServerUrl({
          path: "/auth/signUp/createInvitedUser",
        }),
        requestObj
      );
      const data = _.get(response, "data", {});
      if (_.get(data, "data.isSuccess", false)) {
        aliasUser({ identityString: email });
        dispatch(validateUser({ ...response.data, identityUserType: "staff" }));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
      dispatch(setLoadingState(false));
    } catch (error) {
      dispatch(handleApiError({ error }));
    }
  };
};

export const createInvitedParent = () => {
  return async (dispatch, getState) => {
    try {
      const loginState = getState().login;
      const { firstName, lastName, middleName, token, email } = _.get(
        loginState,
        "formData.createParentAccount",
        {}
      );
      const invitedFamilyData = _.get(loginState, "invitedFamilyData");
      const isV3FlowEnabled = _.get(
        invitedFamilyData,
        "isV3FlowEnabled",
        false
      );
      const invitedFamilyMetadata = _.get(invitedFamilyData, "metadata", null);
      const logId = _.get(invitedFamilyMetadata, "logId", null);
      const requestObj = {
        firstName,
        lastName,
        middleName,
        email,
        region: _.get(loginState, "authRegion", null),
        ...(isV3FlowEnabled ? {} : { logId }),
      };
      dispatch(setLoadingState(true));
      const response = await axios.post(
        getBackendServerUrl({
          path: "/auth/v3/signUp/createInvitedParent",
        }),
        requestObj,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const data = _.get(response, "data", {});
      if (_.get(data, "data.isSuccess", false)) {
        aliasUser({ identityString: email });
        dispatch(
          validateUser({ ...response.data, identityUserType: "parent" })
        );
        dispatch(updateInvitedFamilyData({}));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
      dispatch(setLoadingState(false));
    } catch (error) {
      dispatch(handleApiError({ error }));
    }
  };
};

export const addChildFromInvitedData = () => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const state = getState();
    const invitedFamilyData = state.login.invitedFamilyData;
    const familyInviteCode = _.get(
      invitedFamilyData,
      "metadata.inviteCode",
      ""
    );

    const logId = _.get(invitedFamilyData, "metadata.logId", null);

    const userId = userInfo.id;
    if (_.isEmpty(invitedFamilyData) || !userId || !familyInviteCode) {
      return;
    }

    const childData = await dispatch(
      addChild({
        studentCode: familyInviteCode,
        userId,
        signInFlow: false,
        logId,
      })
    );

    dispatch(updateInvitedFamilyData({}));
    dispatch(updateInvitedFamilyChildData(childData));
  };
};

export const createUnauthenticatedUser = () => {
  return async (dispatch, getState) => {
    try {
      const { selectedSchool: { id: listedOrganizationId } = {} } = _.get(
        getState().login,
        "formData.organizationSelection",
        {}
      );
      const {
        firstName,
        lastName,
        email,
        role,
        password,
        stateCode,
        designation,
      } = _.get(getState().login, "formData.createAccount", {});

      const requestObj = {
        firstName,
        lastName,
        email,
        role,
        designation,
        password,
        listedOrganizationId,
      };

      const query = querystringify.parse(_.get(window, "location.search", ""));
      if (query.utm_token) requestObj.utmToken = query.utm_token;
      if (query.utm_source) requestObj.platform = query.utm_source;

      dispatch(setLoadingState(true));
      const response = await axios.post(
        getBackendServerUrl({
          path: "/auth/signUp/createUnauthenticatedUser",
        }),
        requestObj
      );
      const data = _.get(response, "data", {});

      dispatch(setLoadingState(false));

      dispatch(
        updateInputField("verifyOTP", {
          email,
          id: data.id,
          otp: "",
          stateCode,
        })
      );
      dispatch(updateInputField("addPYPDetails", {}));
      dispatch(updateInputField("addPYPDetails", { id: data.id }));

      if (stateCode == "SUP_DOM_MIS_MTCH_NO_ORG") {
        dispatch(updateInputField("addIdentification", { role, designation }));
        dispatch(updateCurrentScreen({ type: "addIdentification" }));
      } else if (
        !data.isFirstUser ||
        checkIsPYPCoordinator({ role, designation })
      ) {
        dispatch(updateCurrentScreen({ type: "verifyOTP" }));
      } else {
        dispatch(updateCurrentScreen({ type: "addPYPDetails" }));
      }
    } catch (error) {
      dispatch(handleApiError({ error }));
    }
  };
};

export const signInUsingCode = ({
  code,
  codeType = "CODE",
  orgId = undefined,
  goToStudentLoginPageOnError = false,
}) => {
  return async (dispatch, getState) => {
    try {
      const requestNonce = generateRandomNonce(12, "base64");
      const requestObj = {
        classCode: code,
        codeType,
        orgId,
        otpVerificationNonce: requestNonce,
      };
      dispatch(setLoadingState(true));
      const response = await axios.post(
        getBackendServerUrl({
          path: "/auth/v2/student/checkClassCode",
        }),
        requestObj,
        {
          headers: {
            "x-tod-connection-id": await getConnectionId(),
          },
        }
      );
      const data = _.get(response, "data", {});

      if (_.get(data, "isStudentSignIn", false)) {
        const validateNonce = validateRequestNonce({
          token: data.token,
          requestNonce,
        });
        if (!_.get(validateNonce, "isValid")) {
          dispatch(setLoadingState(false));
          dispatch(setToastMsg("toastMsgs:request_verification_failed"));
          return;
        }
        dispatch(validateUser({ ...data, identityUserType: "student" }));
      } else {
        dispatch(
          setToastMsg({
            msg: "Please enter student sign in code",
            notString: true,
          })
        );
      }
    } catch (error) {
      dispatch(handleApiError({ error }));
      if (goToStudentLoginPageOnError) {
        dispatch(
          updateCurrentScreen({
            type: "studentLogin",
            usertype: "student",
            paramsToBeRemoved: ["code"],
          })
        );
      }
    } finally {
      dispatch(setLoadingState(false));
    }
  };
};

export const createSchoolRequest = () => {
  return async (dispatch, getState) => {
    try {
      const {
        name,
        type,
        ibCode,

        firstName,
        lastName,
        email,
        role,
        weburl,
        url,
        designation,
      } = _.get(getState().login, "formData.addSchool", {});

      const requestObj = {
        name,
        type,
        ibCode,
        firstName,
        lastName,
        email,
        role,
        designation,
        weburl,
        url,
      };
      dispatch(setLoadingState(true));
      const response = await axios.post(
        getBackendServerUrl({
          path: "/auth/signUp/createSchoolRequest",
        }),
        requestObj
      );
      dispatch(setLoadingState(false));
      const isSuccess = _.get(response, "data", false);
      if (isSuccess) {
        dispatch(updateInputField("addSchool", {}));
        dispatch(
          updateInputField("requestSuccess", {
            status: "SCHOOL_ADDED",
            firstName,
          })
        );
        dispatch(updateCurrentScreen({ type: "requestSuccess" }));
        aliasUser({ identityString: email });
      }
    } catch (error) {
      dispatch(handleApiError({ error }));
    }
  };
};

export const sendForgotPassword = params => {
  return async (dispatch, getState) => {
    dispatch(setLoadingState(true));
    const { successCallBack, userType = "staff" } = params || {};
    const { email } = _.get(getState().login, "formData.forgotPassword", {});
    try {
      const requestObj = {
        email: email,
        userType,
      };
      const req = await axios.post(
        getBackendServerUrl({
          path: "/auth/v2/forgotPassword",
        }),
        requestObj,
        {
          headers: {
            "x-tod-connection-id": await getConnectionId(),
          },
        }
      );

      dispatch(setLoadingState(false));
      if (successCallBack) {
        successCallBack();
      }
    } catch (error) {
      dispatch(handleApiError({ error }));
    }
  };
};

export const sendResetPassword = params => {
  return async (dispatch, getState) => {
    const { successCallBack, userType = "staff" } = params || {};
    const { phoneNo = "" } = _.get(
      getState().login,
      "formData.resetPassword",
      {}
    );

    if (userType === "parent" && phoneNo) {
      const { password, phoneNo, otp, identityId } = _.get(
        getState().login,
        "formData.resetPassword",
        {}
      );

      const requestObj = {
        phoneNumber: `+${phoneNo}`,
        OTP: otp,
        password,
        userType,
        identityId,
      };
      const url = "/auth/v2/changePassword";
      const response = await dispatch(makeApiRequest({ url, requestObj }));
      const isSuccess = _.get(response, "data.isSuccess", false);
      if (isSuccess) {
        dispatch(
          updateInputField("parentLoginForm", {
            phoneNo,
            phonePassword: password,
          })
        );
        dispatch(
          authenticateUserWithServer({
            method: "local",
            userType,
            isPhoneSignIn: true,
          })
        );
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    } else {
      let formDataKey;

      if (getState().login.currentScreen === "visitorSignup") {
        formDataKey = "visitorSignup";
      } else {
        formDataKey = "resetPassword";
      }

      const { password, id, token, identityId } = _.get(
        getState(),
        `login.formData.${formDataKey}`,
        {}
      );

      try {
        const requestObj = {
          id: id,
          identityId,
          token: token,
          password: password,
          userType,
          isCheckForSuperAdmin: true,
        };
        dispatch(setLoadingState(true));
        const req = await axios.post(
          getBackendServerUrl({
            path: "/auth/v2/resetPassword",
          }),
          requestObj
        );

        await dispatch(
          validateUser({ ...req.data, identityUserType: userType })
        );
        dispatch(setLoadingState(false));
        if (successCallBack) {
          successCallBack();
        }
      } catch (error) {
        dispatch(handleApiError({ error }));
      }
    }
  };
};

export const updateIdentityScreenFilters = ({
  data,
  fetchIdentityUsingRestApi,
}) => {
  return async dispatch => {
    dispatch(setIdentityScreenFilters(data));

    if (fetchIdentityUsingRestApi) {
      dispatch(fetchIdentitiesOnChangeFilters());
    }
  };
};

export const fetchMoreIdentities = () => {
  return async (dispatch, getState) => {
    const state = getState();

    const searchText = _.get(
      state,
      "login.identityScreenFilters.searchText",
      ""
    );

    const { pageInfo, edges: oldEdges } = _.get(
      state,
      "login.identityPoolDetails",
      {}
    );

    const { hasNextPage, endCursor } = pageInfo;

    if (!hasNextPage) {
      return;
    }

    const filters = { first: 20, searchText, after: endCursor };

    dispatch(
      setIdentityPoolDetails({
        pageInfo,
        edges: oldEdges,
        isFetchingMoreData: true,
      })
    );

    const { edges = [], pageInfo: updatedPageInfo = {} } = await dispatch(
      fetchUserIdentities({ filters })
    );

    const updatedEdges = [...oldEdges, ...edges];

    const updatedData = {
      edges: updatedEdges,
      pageInfo: updatedPageInfo,
      isFetchingMoreData: false,
    };

    dispatch(setIdentityPoolDetails(updatedData));
  };
};

export const getUserDetailsFromIdentity = ({
  identityId,
  id: userId,
  userType,
  authenticationCode = "",
  method = "",
}) => {
  return async dispatch => {
    const { token } = getUserInfofromStorage();

    const requestPayload = {
      identityId,
      userId,
      token,
      userType,
      authenticationCode,
      method,
    };

    const response = await dispatch(
      makeApiRequest({
        url: "/auth/identity/user/get",
        requestObj: requestPayload,
      })
    );

    return _.get(response, "data", null);
  };
};

/**It will authenticate users which are  part of
 * more than one organization
 */
export const authenticateUserWithMultipleIdentities = ({
  userParams,
  data,
  hasUserLoggedOut = true,
}) => {
  return async dispatch => {
    /**If user is LoggedIn while authenticating, we don't need
     * to set current user's jwt,id,usertype in localStorage.
     * This data is used to query user's linked identities.
     */
    if (hasUserLoggedOut) {
      /**isIdentitySelected is used to track whether user has chosen
       * any identity after opening organization switcher.It will be removed
       * after authentication.
       */
      const updatedUserParams = { ...userParams, isIdentitySelected: false };
      dispatch(setUserInfoInReduxAndStorage(updatedUserParams));
    }

    dispatch(setLoadingState(false));

    dispatch(
      updateOrganizationSwitcherDetails({
        isVisible: true,
        userId: data.id,
        userEntityType: userParams.userEntityType,
      })
    );
  };
};

export const logBulkActionActivity = async ({ input }) => {
  try {
    if (!ACLStore.can("FeatureFlag:ActivityLogForBulkActions")) return;
    await client.mutate({
      mutation: logUserActivityMutation,
      variables: {
        input: {
          ...input,
          logType: "INTERNAL",
        },
      },
    });
  } catch (error) {
    // silently fail, shouldn't block the main action
  }
};

export const logUserActivity = ({ input }) => {
  return async (dispatch, getState) => {
    try {
      const isStaff = getIsStaff(getState());
      if (!isStaff) {
        return false;
      }
      const mutationData = await client.mutate({
        mutation: logUserActivityMutation,
        variables: { input },
      });
      return _.get(mutationData, "data.platform.logUserActivity", false);
    } catch (error) {
      return false;
    }
  };
};

const logUserLogoutActivity = async dispatch => {
  if (ACLStore.can(ENABLE_ACTIVITY_LOGGING)) {
    await dispatch(
      logUserActivity({
        input: {
          operation: "UPDATE",
          module: "module_authentication",
          activityType: "LOGGED_OUT",
          description: "logged out",
        },
      })
    );
  }
};

/**
 * This util will decide next authentication flow after Organization is selected based on following conditions:
 * A. If user is logged in and opens select organization screen -> onSwitchToOrganizationLocally
 * B. Else -> setUserFromIdentityPoolUserList
 */
export const onSelectOrganization = params => {
  return async (dispatch, getState) => {
    const isMfaEnabled = _.get(params, "isMfaEnabled", false);
    const jwt = _.get(params, "jwt", null);
    const showVerificationMFAModal = !jwt && isMfaEnabled;
    const isUserLoggedIn = _.get(getState(), "login.userLoggedIn", false);

    if (showVerificationMFAModal) {
      dispatch(
        updateMfaVerificationDetails({
          isVisible: true,
          userType: _.get(params, "type", "") || _.get(params, "userType", ""),
          userId: _.get(params, "id", ""),
          organization: _.get(params, "organization", ""),
          identityId: _.get(params, "identityId"),
          designation: _.get(params, "designation"),
          emailSource: _.get(params, "emailSource"),
          mfaEnabledMethods: _.get(params, "mfaEnabledMethods", []),
          isUserLoggedIn,
        })
      );
      return;
    }

    if (isUserLoggedIn) {
      // Cleanup WalkMe script, if any
      WalkMeManager.cleanup();
      await logUserLogoutActivity(dispatch);
      setIsUserLoginActivityLogged(false);
      dispatch(onSwitchToOrganizationLocally(params));
    } else {
      dispatch(setUserFromIdentityPoolUserList(params));
    }
  };
};

export const addUserImpersonation = ({
  userId,
  contextId = null,
  contextType = null,
}) => {
  return async dispatch => {
    try {
      dispatch(setFullScreenLoading(true));

      const result = await client.mutate({
        mutation: addUserImpersonationMutation,
        variables: {
          input: {
            userId,
            ...(contextType ? { contextType } : {}),
            ...(contextId ? { contextId } : {}),
          },
        },
      });

      dispatch(setFullScreenLoading(false));

      const isSuccess = _.get(
        result,
        "data.platform.addUserImpersonation.isSuccess",
        false
      );

      if (!isSuccess) {
        throw new Error("Failed to impersonate user");
      }

      const currentPath = window.location.pathname;
      localStorage.setItem("preImpersonationPath", currentPath);

      const userInfo = _.get(
        result,
        "data.platform.addUserImpersonation.edge.node",
        {}
      );

      const { id, jwt, type, identityId, designation } = userInfo;

      let role;
      if (designation.id == DESIGNATION_IDS_MAP[VISITOR]) {
        role = ROLE_VISITOR;
      }

      const data = {
        id,
        org_id: _.get(userInfo, "organization.id"),
        identityId,
        token: jwt,
        user_type: type,
        userEntityType: _.get(USER_TYPE_ENTITY_MAPPING[type], "entityType", ""),
        ...(role ? { role } : {}),
      };

      //clear external storage when user switches to another organization if apollo cache persistence is enabled.

      if (window.__IS_CACHE_PERSISTENCE_ENABLED__) {
        await persistor.purge();
        persistor.pause();
      }

      dispatch(setUserInfoInReduxAndStorage(data));
      history.replaceState(null, document.title, "/");
      window.location.href = "/";
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const removeUserImpersonation = ({
  userId,
  identityId: loggedInUserIdentityId,
}) => {
  localStorage.setItem("isRemovingImpersonation", "true");

  return async dispatch => {
    try {
      dispatch(setFullScreenLoading(true));

      const result = await client.mutate({
        mutation: removeUserImpersonationMutation,
        variables: {
          input: {
            userId,
            identityId: loggedInUserIdentityId,
          },
        },
      });

      dispatch(setFullScreenLoading(false));

      const isSuccess = _.get(
        result,
        "data.platform.removeUserImpersonation.isSuccess",
        false
      );

      if (!isSuccess) {
        throw new Error("Failed to remove impersonation");
      }

      const userInfo = _.get(
        result,
        "data.platform.removeUserImpersonation.edge.node",
        {}
      );

      const { id, jwt, type, identityId, designation } = userInfo;

      let role;
      if (designation.id == DESIGNATION_IDS_MAP[VISITOR]) {
        role = ROLE_VISITOR;
      }

      const data = {
        id,
        org_id: _.get(userInfo, "organization.id"),
        identityId,
        token: jwt,
        user_type: type,
        userEntityType: _.get(USER_TYPE_ENTITY_MAPPING[type], "entityType", ""),
        ...(role ? { role } : {}),
      };

      //clear external storage when user switches to another organization if apollo cache persistence is enabled.

      if (window.__IS_CACHE_PERSISTENCE_ENABLED__) {
        await persistor.purge();
        persistor.pause();
      }

      dispatch(setUserInfoInReduxAndStorage(data));
      window.location.href = "/";
      history.replaceState(null, document.title, "/");
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

/**
 * This function will fetch user details based on selected identity, and updates redux and
 * localStorage. From here, user is considered as logged in
 */
export const setUserFromIdentityPoolUserList = params => {
  return async dispatch => {
    const userDetails = await dispatch(getUserDetailsFromIdentity(params));

    dispatch(setLoadingState(true));

    if (_.isEmpty(userDetails)) {
      dispatch(setLoadingState(false));
      return;
    }

    if (_.get(params, "shouldCloseVerificationModal", false)) {
      dispatch(
        updateMfaVerificationDetails({
          isVisible: false,
        })
      );
    }

    const { token, data } = userDetails;

    const { id, user_type: userType, org_id, identity_id_v2, roles } = data;

    let role;
    if (_.includes(roles, ROLE_VISITOR)) {
      role = ROLE_VISITOR;
    }

    const userParams = {
      token,
      id: _.toString(id),
      user_type: userType,
      org_id: _.toString(org_id),
      userEntityType: _.get(
        USER_TYPE_ENTITY_MAPPING[userType],
        "entityType",
        ""
      ),
      ...(role ? { role } : {}),
    };

    if (identity_id_v2) {
      userParams["identityId"] = identity_id_v2;
    }

    dispatch(setUserInfoInReduxAndStorage(userParams));

    dispatch(
      updateOrganizationSwitcherDetails({
        isVisible: false,
      })
    );

    dispatch(setIdentityScreenFilters({}));

    dispatch(setIdentityPoolDetails(null));

    const userData = {
      ...data,
      id: _.toString(_.get(data, "id", "")),
      org_id: _.toString(_.get(data, "org_id", "")),
    };

    await dispatch(_onUserAuthentication(userData));
  };
};

export const fetchUserIdentities = ({ filters }) => {
  return async dispatch => {
    const {
      id: identityId,
      token,
      identityUserType,
    } = getUserInfofromStorage();

    /**
     * Can't use makeApiRequest as we don't need to change loading status
     */

    try {
      const response = await axios.post(
        getBackendServerUrl({ path: "/auth/identity/user/list" }),
        {
          identityId,
          token,
          userType: identityUserType,
          filters,
        }
      );

      return response?.data ?? {};
    } catch (e) {
      dispatch(handleApiError({ error: e }));
      return {};
    }
  };
};

export const fetchIdentitiesOnChangeFilters = () => {
  return async (dispatch, getState) => {
    const state = getState();

    const identityPoolDetails = _.get(state, "login.identityPoolDetails", {});

    dispatch(
      setIdentityPoolDetails({ ...identityPoolDetails, isLoading: true })
    );

    const searchText = _.get(
      state,
      "login.identityScreenFilters.searchText",
      ""
    );

    const { edges, pageInfo } = await dispatch(
      fetchUserIdentities({ filters: { first: 20, searchText } })
    );

    const updatedState = getState();

    const updatedSearchText = _.get(
      updatedState,
      "login.identityScreenFilters.searchText",
      ""
    );

    /**
     * To avoid race condition, we compare latest search Text with search Text before request.
     * Here, during an ongoing request, if user triggers another request, search text will be different in redux.
     * Request for which old and new searchText is same, corresponding data will be added in redux.
     */
    if (searchText === updatedSearchText) {
      const data = { edges, pageInfo, isLoading: false };
      dispatch(setIdentityPoolDetails(data));
    }
  };
};

const authenticateUserWithIdentityPool = ({ userParams, data }) => {
  return async dispatch => {
    dispatch(
      setUserInfoInReduxAndStorage({ ...userParams, isIdentitySelected: false })
    );

    const redirectionEmailUrlParams = extractDataFromEmailRedirectionUrl(
      window.location.href
    );
    const { edges, pageInfo } = await dispatch(
      fetchUserIdentities({
        filters: redirectionEmailUrlParams
          ? { searchText: redirectionEmailUrlParams?.metadata?.orgId }
          : { first: 20 },
      })
    );

    const updatedData = { ...data, edges, pageInfo };

    const userEdges = _.get(updatedData, "edges", []);

    const totalIdentities = _.size(userEdges);

    if (totalIdentities === 1) {
      const { identity_id: identityId, user_id, user_type: userType } = _.get(
        _.first(userEdges),
        "node",
        {}
      );

      dispatch(
        setUserFromIdentityPoolUserList({
          identityId,
          userType,
          id: user_id,
        })
      );

      return;
    }

    dispatch(setIdentityPoolDetails(updatedData));
    dispatch(
      updateOrganizationSwitcherDetails({
        isVisible: true,
      })
    );
    dispatch(setLoadingState(false));
  };
};

export const validateUser = params => {
  return async dispatch => {
    const { data, token, identityUserType, idpCode } = params;

    const { user_type: userType, identity_id: identityId, roles } = data;

    let role;
    if (_.includes(roles, ROLE_VISITOR)) {
      role = ROLE_VISITOR;
    }

    const userParams = {
      token,
      id: _.toString(data.id || data.identity_id),
      org_id: _.toString(_.get(params, "data.org_id")),
      user_type: params.data.user_type,
      userEntityType: _.get(
        USER_TYPE_ENTITY_MAPPING[userType],
        "entityType",
        ""
      ),
      idpCode,
      identityUserType,
      ...(role ? { role } : {}),
    };

    const userData = {
      ...data,
      id: _.toString(_.get(data, "id", "")),
      org_id: _.toString(_.get(data, "org_id", "")),
    };

    switch (userType) {
      case "parent": {
        /** __FamilyPortal__
         * In family portal 2 jwt are stored
         * 1. parentToken: jwt of parent
         * 2. token: jwt of child (will be available after querying "getPlatformUserDetailsQuery" in ChildrenPage.js)
         * Note: Because of below condition parentToken will be stored in local storage for user_type = parent
         * */

        const updatedUserParams = {
          ...userParams,
          parentToken: token,
        };
        dispatch(setUserInfoInReduxAndStorage(updatedUserParams));
        await dispatch(_onUserAuthentication(userData));
        return;
      }

      case "super_admin": {
        await dispatch(
          _onSAUserAuthentication({ token: userParams.token, ...data })
        );
        return;
      }

      case "identity_user": {
        await dispatch(
          authenticateUserWithIdentityPool({
            userParams,
            data,
          })
        );
        break;
      }

      default: {
        dispatch(setUserInfoInReduxAndStorage(userParams));
        await dispatch(_onUserAuthentication(userData));
      }
    }
  };
};

export const callSamlGenerateApi = ({
  idpIdentificationId,
  relayState = "",
  requestInfo = "",
  token = "",
  openInNewTab = false,
}) => {
  return async dispatch => {
    try {
      dispatch(setLoadingState(true));
      const userInfo = getUserInfo();
      const requestObj = {
        idpIdentificationId,
        relayState,
        requestInfo,
      };
      const authToken = token || userInfo.token;

      const response = await axios.post(
        getBackendServerUrl({
          path: `/auth/v2/saml/sp/generateAcs/${idpIdentificationId}`,
        }),
        requestObj,
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );

      const data = _.get(response, "data", {});
      const isSuccess = _.get(data, "isSuccess", false);
      if (isSuccess) {
        dispatch(
          setSamlInitiatedDetails({
            redirectUrl: _.get(data, "redirectUrl", ""),
            samlResponse: _.get(data, "SAMLResponse", ""),
            relayState: _.get(data, "RelayState", ""),
            isInitiated: true,
            openInNewTab,
          })
        );
      } else {
        if (_.get(data, "error") === "INTERNAL_SERVER_ERROR") {
          dispatch(setToastMsg("toastMsgs:internal_server_error"));
        } else {
          dispatch(setToastMsg("toastMsgs:something_went_wrong"));
        }
      }
    } catch (error) {
      dispatch(handleApiError({ error }));
    } finally {
      dispatch(setLoadingState(false));
      clearSamlInitiatedDetails();
    }
  };
};

export const getIdpUrlFromServer = requestObj => {
  return async dispatch => {
    await dispatch(setLoadingState(true));

    const url = "/auth/v2/saml/fetchSSOUrl";

    const response = await dispatch(makeApiRequest({ url, requestObj }));

    const isSuccess = _.get(response, "data.isSuccess", false);

    const idpList = _.get(response, "data.idp", []);

    const errorMessage = _.get(response, "data.errorMesaage", "");

    if (!isSuccess) {
      if (errorMessage === "IDP_CONFIG_NOT_FOUND") {
        dispatch(setToastMsg("toastMsgs:idp_not_found"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
      return;
    }

    await dispatch(setLoadingState(false));

    if (_.size(idpList) > 1) {
      dispatch(setIdpsList(idpList));
      return;
    } else {
      const idp = _.first(idpList);

      const url = getSamlBackendRedirectUrl({
        idpId: idp.id,
        userType: requestObj.userType,
        schoolCode: requestObj.schoolCode,
      });

      //redirect to backend
      window.location.replace(url);
    }
  };
};

export const authenticateUserWithServer = params => {
  return async (dispatch, getState) => {
    await dispatch(setLoadingState(true));
    const {
      idToken,
      codeVerifier,
      source,
      method = "google",
      userType = "staff",
      isPhoneSignIn = false,
      redirectUri = "",
      isEmailOTPSignIn = false,
      encryptedMessage,
      schoolName,
      orgId,
      callbackFn = () => {},
      mobileDevice = false,
      isToddleInitiated = true,
      isMobileReq,
      service,
    } = params;

    const loginState = getState().login;
    const currentScreen = _.get(loginState, "currentScreen");
    let requestNonce = null;

    let requestObj = {
      method: method,
      userType,
      //userType: "staff",
      isCheckForSuperAdmin: true,
      redirectUri,
      orgId,
      isToddleInitiated,
    };

    if (
      method == "google" ||
      method == "googleV2" ||
      method == "microsoft" ||
      method == "url" ||
      method === "clever" ||
      method === "lex" ||
      method === "classlink" ||
      method === "irmak" ||
      method === "veracross" ||
      method === "shriconnect" ||
      method === "vedanya" ||
      method === "rpgis" ||
      method === "prometheus" ||
      method === "kulish" ||
      method === "pilot-lex" ||
      method === "saml" ||
      method === "my-school" ||
      method === "pips" ||
      method === "blackbaud" ||
      method === "sentral"
    ) {
      requestObj = {
        ...requestObj,
        idToken,
        codeVerifier,
      };

      //condition for irmak
      if (method === "irmak") {
        requestObj = {
          ...requestObj,
          source,
        };
      }

      //condition for veracross
      if (method === "veracross") {
        requestObj = {
          ...requestObj,
          schoolRoute: schoolName,
        };
      }
      if (method === "saml") {
        requestNonce = generateRandomNonce(12, "base64");
        requestObj = {
          encryptedMessage,
          userType,
          isToddleInitiated,
          isMobileReq,
          service,
          method,
          otpVerificationNonce: requestNonce,
        };
      }

      if (method === "my-school") {
        requestObj = {
          ...requestObj,
          schoolName,
        };
      }

      if (method === "blackbaud") {
        requestObj = {
          idToken,
          method,
          school: schoolName,
          isToddleInitiated,
        };
      }

      if (method === "sentral") {
        requestObj = {
          ...requestObj,
          idToken,
          method,
          school: schoolName,
        };
      }

      // TODO:- Temporarily we are not allowing forced signup for parent, we will allow this in near future once backend is compatible
      // if (userType === "parent") {
      //   requestObj = {
      //     ...requestObj,
      //     isForcedSignUp: true,
      //   };
      // }
    } else if (method === "local" && isPhoneSignIn) {
      if (currentScreen === "loginWithPhoneOTP") {
        const { phoneNo, otp } = _.get(
          loginState,
          "formData.loginWithPhoneOTP",
          {}
        );

        requestNonce = generateRandomNonce(12, "base64");
        requestObj = {
          ...requestObj,
          phoneNumber: `+${phoneNo}`,
          OTP: otp,
          loginType: "OTP",
          otpVerificationNonce: requestNonce,
        };
      } else if (currentScreen === "loginFormV2") {
        const { phoneNo, otp } = _.get(loginState, "formData.loginFormV2", {});

        requestNonce = generateRandomNonce(12, "base64");
        requestObj = {
          ...requestObj,
          phoneNumber: `+${phoneNo}`,
          OTP: otp,
          loginType: "OTP",
          otpVerificationNonce: requestNonce,
        };
      } else {
        if (currentScreen === "loginFormV3") {
          const { phoneNo, otp } = _.get(
            loginState,
            "formData.loginFormV3",
            {}
          );

          requestNonce = generateRandomNonce(12, "base64");
          requestObj = {
            ...requestObj,
            phoneNumber: `+${phoneNo}`,
            OTP: otp,
            loginType: "OTP",
            otpVerificationNonce: requestNonce,
          };
        } else {
          // Cannot restrict this code only to "parentLoginForm" because
          // there are other screens like verifyOTP, verifyPhoneOTP which uses
          // parentLoginForm to access phoneNo and password
          const { phoneNo, phonePassword } = _.get(
            loginState,
            "formData.parentLoginForm",
            {}
          );

          requestObj = {
            ...requestObj,
            phoneNumber: `+${phoneNo}`,
            password: phonePassword,
          };
        }
      }
    } else if (method === "local" && isEmailOTPSignIn) {
      const formDataKey =
        currentScreen === "loginFormV3" ? "loginFormV3" : "loginFormV2";
      const { email = "", otp = "" } = _.get(
        loginState,
        `formData.${formDataKey}`,
        {}
      );
      requestNonce = generateRandomNonce(12, "base64");

      requestObj = {
        ...requestObj,
        email,
        otp,
        otpVerificationNonce: requestNonce,
        otpType: OTP_TYPE.EMAIL_LOGIN,
      };
    } else if (method === "local") {
      let email, password;
      if (currentScreen === "loginFormV3") {
        email = _.get(loginState, "formData.loginFormV3.email", "");
        password = _.get(loginState, "formData.loginFormV3.password", "");
      } else if (
        userType === "parent" &&
        !getIsNewLoginFlowEnabled({ userType: "parent" })
      ) {
        email = _.get(getState().login, "formData.parentLoginForm.email", "");
        password = _.get(loginState, "formData.parentLoginForm.password", "");
      } else {
        email = _.get(getState().login, "formData.loginForm.email", "");
        password = _.get(getState().login, "formData.loginForm.password", "");
      }

      requestObj = {
        ...requestObj,
        email: email,
        password: password,
      };
    }

    try {
      let path = "/auth/v2/signIn";

      if (method === "saml") {
        path = "/auth/v2/saml/fetchJwt";
      }

      const req = await axios.post(
        getBackendServerUrl({
          path,
        }),
        requestObj,
        {
          headers: {
            "x-tod-connection-id": await getConnectionId(),
          },
        }
      );

      const responseData = _.get(req, "data.data", {});
      const samlInitiatedDetails = getSamlInitiatedDetails();
      if (_.get(samlInitiatedDetails, "isInitiated", false)) {
        dispatch(
          callSamlGenerateApi({
            idpIdentificationId: _.get(
              samlInitiatedDetails,
              "idpIdentificationId",
              ""
            ),
            relayState: _.get(samlInitiatedDetails, "relayState", ""),
            requestInfo: _.get(samlInitiatedDetails, "requestInfo", ""),
            token: _.get(req, "data.token", ""),
          })
        );
      }

      const {
        is_password_updated = false,
        user_type: userType,
        idpCode,
      } = responseData;

      if (method === "blackbaud" && mobileDevice) {
        dispatch(setLoadingState(false));
        callbackFn({ userType, idToken, schoolName, isToddleInitiated });
        return;
      }

      const skipResetPasswordScreens = ["loginWithPhoneOTP", "loginFormV2"];

      const shouldSkipResetPasswordScreen = _.get(
        loginState,
        "formData.loginFormV3.shouldSkipResetPasswordScreen",
        true
      );
      if (!_.has(req.data, "mfaToken")) {
        const validateNonce = validateRequestNonce({
          token: req.data.token,
          requestNonce,
        });
        if (!_.get(validateNonce, "isValid")) {
          dispatch(setLoadingState(false));
          dispatch(setToastMsg("toastMsgs:request_verification_failed"));
          return false;
        }
      }

      if (
        (currentScreen !== "loginFormV3" &&
          !_.includes(["super_admin"], userType) &&
          !is_password_updated &&
          method == "local" &&
          !_.includes(skipResetPasswordScreens, currentScreen)) ||
        (currentScreen === "loginFormV3" && !shouldSkipResetPasswordScreen)
      ) {
        dispatch(setLoadingState(false));
        dispatch(updateCurrentScreen({ type: "resetPassword" }));
        dispatch(updateInputField("resetPassword", {}));
        dispatch(
          updateInputField("resetPassword", {
            id: req.data.data.id,
            identityId: req.data.data.identity_id,
            token: req.data.token,
          })
        );

        return false;
      }

      const data = _.get(req, "data", {});

      if (_.has(data, "mfaToken")) {
        dispatch(setLoadingState(false));
        dispatch(
          updateMfaVerificationDetails({
            isVisible: true,
            mfaToken: _.get(data, "mfaToken", ""),
            userType: requestObj.userType,
            mfaEnabledMethods: _.get(data, "mfaEnabledMethods", []),
          })
        );
        return false;
      }

      dispatch(
        validateUser({
          ...req.data,
          identityUserType: requestObj.userType,
          idpCode,
        })
      );
    } catch (error) {
      if (
        _.isEmpty(requestObj["email"]) &&
        _.isEmpty(requestObj["password"]) &&
        requestObj["method"] === "local"
      ) {
        Sentry.withScope(scope => {
          const loginState = _.get(getState(), "login");
          scope.setExtra("formData", _.get(loginState, "formData"));
          scope.setExtra("params", params);
          scope.setExtra("currentScreen", _.get(loginState, "currentScreen"));
          scope.setTag("origin", "authenticateUserWithServer");
          Sentry.captureMessage(`${error.message}`);
        });
      }
      if (["saml", "pips", "classlink"].includes(requestObj.method)) {
        dispatch(setSsoRequestInitiatedFailed(true));
      }
      dispatch(handleApiError({ error }));
    }
  };
};

export const verifySessionWithServer = () => {
  return async (dispatch, getState) => {
    dispatch(setLoadingState(true));
    const loginState = _.get(getState(), "login");

    const userId = _.get(loginState, "userInfo.id");
    const userEntityType = _.get(loginState, "userInfo.userEntityType");

    // current details
    const platformUserDetails = getPlatformUserDetailsFromCache({
      id: userId,
      type: userEntityType,
    });
    const platformStaffIdentityDetails = getPlatformStaffIdentityDetailsFromCache(
      {
        id: userId,
        type: userEntityType,
        portalType: "PLANNER",
      }
    );
    const userInfo = getUserInfofromStorage();
    const userIdentityDetails = _.get(loginState, "userIdentityDetails", []);
    const requestNonce = generateRandomNonce(12, "base64");

    const requestObj = {
      method: "local",
      userType: _.get(loginState, "userInfo.user_type"),
      email: _.get(loginState, "userInfo.email"),
      otpVerificationNonce: requestNonce,
      otp: _.get(loginState, "sessionVerificationDetails.otp"),
      otpType: OTP_TYPE.SESSION_VERIFICATION,
      isCheckForSuperAdmin: true,
      redirectUri: "",
      orgId: _.get(loginState, "userInfo.org_id"),
    };

    try {
      const path = "/auth/v2/signIn";

      const req = await axios.post(
        getBackendServerUrl({
          path,
        }),
        requestObj,
        {
          headers: {
            "x-tod-connection-id": await getConnectionId(),
          },
        }
      );

      const responseData = _.get(req, "data", {});

      if (!_.isEmpty(responseData)) {
        const { data, token } = responseData;

        const validateNonce = validateRequestNonce({
          token,
          requestNonce,
        });
        if (!_.get(validateNonce, "isValid")) {
          dispatch(setLoadingState(false));
          dispatch(setToastMsg("toastMsgs:request_verification_failed"));
          return false;
        }

        const {
          user_type: userType,
          identity_id: identityId,
          roles,
          id,
          org_id: orgId,
          identityUserType = "staff",
        } = data;

        let role;
        if (_.includes(roles, ROLE_VISITOR)) {
          role = ROLE_VISITOR;
        }

        let userParams = {
          token,
          id: _.toString(id || identityId),
          org_id: _.toString(orgId),
          user_type: userType,
          userEntityType: _.get(
            USER_TYPE_ENTITY_MAPPING[userType],
            "entityType",
            ""
          ),
          identityUserType,
          ...(role ? { role } : {}),
        };

        if (userType === "parent") {
          userParams = {
            ...userParams,
            parentToken: token,
          };
        }

        // update cache of getPlatformUserDetailsQuery with new jwt
        cache.updateQuery(
          {
            query: getPlatformUserDetailsQuery,
            variables: {
              id: userId,
              type: userEntityType,
            },
          },
          data => {
            const updatedData = update(data, {
              node: {
                jwt: {
                  $set: token,
                },
              },
            });

            return updatedData;
          }
        );

        // update cache of PLANNER portal of getPlatformStaffIdentityDetailsQuery with new jwt
        cache.updateQuery(
          {
            query: getPlatformStaffIdentityDetailsQuery,
            variables: {
              id: userId,
              type: userEntityType,
              portalType: "PLANNER",
            },
          },
          data => {
            const identities = _.get(data, "node.userIdentityDetails", []);
            const updatedData = update(data, {
              node: {
                userIdentityDetails: {
                  $set: _.map(identities, identity => {
                    if (identity.portalType === "PLANNER") {
                      const linkedUser = identity.linkedUser;
                      return {
                        ...identity,
                        linkedUser: {
                          ...linkedUser,
                          jwt: token,
                        },
                      };
                    } else {
                      return identity;
                    }
                  }),
                },
              },
            });

            return updatedData;
          }
        );

        // update localstorage and redux
        dispatch(
          setUserInfoInReduxAndStorage({
            ...userInfo,
            ...userParams,
            jwt: token,
          })
        );

        // update token in user identity
        dispatch(
          setUserIdentityDetails(
            _.map(_.get(loginState, "userIdentityDetails", []), identity => {
              if (identity.portalType === "PLANNER") {
                return {
                  ...identity,
                  jwt: token,
                  token,
                };
              } else {
                return identity;
              }
            })
          )
        );

        if (userType === "parent") {
          await client.query({
            query: getChildrenQuery,
            variables: {
              id: userId,
              type: "FAMILY_MEMBER",
            },
            fetchPolicy: "network-only",
          });
        }

        dispatch(updateSessionVerificationDetails({ isVisible: false }));
        dispatch(handleNavigateWithSessionCheck());
        dispatch(setLoadingState(false));

        return { isSuccess: true };
      }
    } catch (error) {
      // revert cache changes
      cache.updateQuery(
        {
          query: getPlatformUserDetailsQuery,
          variables: {
            id: userId,
            type: userEntityType,
          },
        },
        data => {
          const updatedData = update(data, {
            node: {
              $set: platformUserDetails,
            },
          });

          return updatedData;
        }
      );

      cache.updateQuery(
        {
          query: getPlatformStaffIdentityDetailsQuery,
          variables: {
            id: userId,
            type: userEntityType,
            portalType: "PLANNER",
          },
        },
        data => {
          const updatedData = update(data, {
            node: {
              $set: platformStaffIdentityDetails,
            },
          });

          return updatedData;
        }
      );

      // revert local storage and redux changes
      dispatch(setUserInfoInReduxAndStorage(userInfo));
      dispatch(setUserIdentityDetails(userIdentityDetails));

      dispatch(setLoadingState(false));
      dispatch(updateSessionVerificationDetails({ otp: "" }));
      dispatch(handleApiError({ error }));
    }
  };
};

export const getLoginConfig = data => {
  return async dispatch => {
    const { schoolCode, successCallback, errorCallback } = data;

    await dispatch(setLoadingState(true));
    try {
      const response = await axios.get(
        getBackendServerUrl({
          path: `/auth/fetchLoginConfig?school_code=${_.toLower(schoolCode)}`,
        })
      );

      const isSuccess = _.get(response, "data.isSuccess", false);

      const errorMessage = _.get(response, "data.errorMessage", "");

      if (!isSuccess) {
        if (errorMessage === "SCHOOL_NOT_FOUND") {
          dispatch(setToastMsg("toastMsgs:invalid_school_code"));
        } else {
          dispatch(setToastMsg("toastMsgs:something_went_wrong"));
        }

        if (_.isFunction(errorCallback)) {
          errorCallback();
        }

        return;
      }

      dispatch(
        setOrgWorkSpaceDetailsInReduxAndStorage(
          _.get(response, "data.data", {})
        )
      );

      if (_.isFunction(successCallback)) {
        const organizationId = _.get(
          response,
          "data.data.organizationId",
          null
        );
        await successCallback(organizationId);
      }
    } catch (error) {
      dispatch(handleApiError({ error }));

      if (_.isFunction(errorCallback)) {
        errorCallback();
      }
    } finally {
      dispatch(setLoadingState(false));
    }
  };
};

export const generateEmailOTPForSessionVerification = props => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();

    const requestObj = {
      email: userInfo.email,
      userType: userInfo.user_type,
      otpType: OTP_TYPE.SESSION_VERIFICATION,
    };

    const { isSuccess, RESEND_TIMER } = await dispatch(
      generateEmailOTP(requestObj)
    );

    if (isSuccess) {
      if (RESEND_TIMER < 15) {
        dispatch(
          setToastMsg({
            msg: `toastMsgs:request_otp_after_timer`,
            type: "warning",
            locale_params: [
              {
                key: "timer",
                value: RESEND_TIMER,
                isPlainText: true,
              },
            ],
            notString: true,
          })
        );
      } else {
        dispatch(
          setToastMsg({
            msg: `toastMsgs:otp_sent_to_verified_email`,
            type: "success",
          })
        );
      }

      dispatch(updateSessionVerificationDetails({ RESEND_TIMER }));
    }

    return { isSuccess };
  };
};

export const onSwitchToUserFromSA = params => {
  return async (dispatch, getState) => {
    await dispatch(setLoadingState(true));
    try {
      const token = getState().login.sa.token;
      const userId = params.userId;
      const req = await axios.post(
        getBackendServerUrl({
          token,
          path: "/auth/super_admin/get_user",
        }),
        { token, userId }
      );
      const userParams = {
        org_id: _.toString(req.data.data.org_id),
        token: req.data.token,
        id: _.toString(req.data.data.id),
        user_type: req.data.data.user_type,
        userEntityType: _.get(
          USER_TYPE_ENTITY_MAPPING[req.data.data.user_type],
          "entityType",
          ""
        ),
      };
      await dispatch({ type: REMOVE_SUPERADMIN_AUTH });
      dispatch(setUserInfoInReduxAndStorage(userParams));
      await dispatch(_onUserAuthentication(req.data.data));
    } catch (error) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      dispatch(setLoadingState(false));
    }
  };
};

export const onSwitchToOrganization = params => {
  return async (dispatch, getState) => {
    dispatch(setLoadingState(false));
    const state = getState();
    try {
      const portalType = _.get(state, "login.portalType", null);
      const userInfo = getUserInfo({ portalType });
      const token = userInfo.token;
      const organizationId = params.organizationId;
      const req = await axios.post(
        getBackendServerUrl({
          token,
          path: "/auth/super_admin/get_user",
        }),
        { token, organizationId }
      );

      //clear external storage when user switches to another organization if apollo cache persistence is enabled.
      if (window.__IS_CACHE_PERSISTENCE_ENABLED__) {
        await persistor.purge();
        persistor.pause();
      }

      const response = _.get(req, "data.data", {});
      const userParams = {
        org_id: _.toString(response.org_id),
        token: req.data.token,
        id: _.toString(response.id),
        user_type: response.user_type,
        userEntityType: _.get(
          USER_TYPE_ENTITY_MAPPING[response.user_type],
          "entityType",
          ""
        ),
      };

      if (response.identity_id_v2) {
        userParams["identityId"] = response.identity_id_v2;
      }

      dispatch(setUserInfoInReduxAndStorage(userParams));
      window.location.href = "/";
    } catch (error) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    } finally {
      dispatch(setLoadingState(false));
    }
  };
};

export const authorizeUserWithOauth2 = params => {
  return async (dispatch, getState) => {
    await dispatch(setLoadingState(true));
    try {
      const userInfo = getUserInfofromStorage();
      const token = _.get(userInfo, "token");
      const service = _.get(params, "service");
      const clientId = _.get(params, "clientId");
      const state = _.get(params, "state");
      const openInNewTab = _.get(params, "openInNewTab", true);

      const req = await axios.post(
        getBackendServerUrl({
          token,
          path: "/auth/v2/oauth/authorize",
        }),
        { serviceName: service, clientId, state },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const redirectUrl = _.get(req, "data.response.redirectUrl", {});

      if (openInNewTab) {
        dispatch(setLoadingState(false));
        dispatch(openLinkInNewTab({ url: redirectUrl }));
      } else {
        window.location.href = redirectUrl;
      }
    } catch (error) {
      dispatch(handleApiError({ error }));
      dispatch(setLoadingState(false));
    }
  };
};

export const onSwitchToOrganizationLocally = params => {
  return async dispatch => {
    const { id, jwt, type, identityId, designation, emailSource } =
      params || {};

    let role;
    if (designation?.id == DESIGNATION_IDS_MAP[VISITOR]) {
      role = ROLE_VISITOR;
    }

    const data = {
      id,
      org_id: _.get(params, "organization.id"),
      identityId,
      token: jwt,
      user_type: type,
      userEntityType: _.get(USER_TYPE_ENTITY_MAPPING[type], "entityType", ""),
      ...(role ? { role } : {}),
    };

    //clear external storage when user switches to another organization if apollo cache persistence is enabled.
    if (window.__IS_CACHE_PERSISTENCE_ENABLED__) {
      await persistor.purge();
      persistor.pause();
    }

    try {
      dispatch(setUserInfoInReduxAndStorage(data));
      if (!emailSource) {
        const postOrgSwitchPath = localStorage.getItem("postOrgSwitchPath");
        if (postOrgSwitchPath) {
          localStorage.removeItem("postOrgSwitchPath");
          localStorage.setItem("pendingRedirectPath", postOrgSwitchPath);
        }
        window.location.href = "/";
      }
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

const _onSAUserAuthentication = data => {
  return async (dispatch, getState) => {
    await dispatch(authSuperAdminSuccess(data));
    await dispatch(setLoadingState(false));
  };
};

const _onUserAuthentication = data => {
  return async (dispatch, getState) => {
    const storageData = getUserInfofromStorage() || {};
    dispatch(
      setUserInfoInReduxAndStorage({
        ...storageData,
        ...(data || {}),
        userLoggedIn: true,
      })
    );

    await dispatch(
      authUserSuccessAction({ ...(data || {}), userLoggedIn: true })
    );

    await dispatch(_fetchData());
    await dispatch(setLoadingState(false));
    await dispatch(_doTransition());
  };
};

const _redirectToToddleAcademy = ({ userId }) => {
  return async dispatch => {
    const url = await dispatch(
      getWorkrampLoginUrl({ id: userId, type: "STAFF" })
    );
    if (!_.isEmpty(url)) {
      window.location.href = url;
    }
  };
};

export const _fetchData = () => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const user_type = userInfo.user_type;
    const userId = userInfo.id;
    const query = getCurrentQuery();

    dispatch(setLoadingState(true));

    await dispatch(_setupApolloCachePersistence());

    const isRedirectToddleacademy = _.get(query, "redirect_toddleacademy");
    if (
      _.isEqual(user_type, "staff") &&
      !_.isEmpty(userId) &&
      _.isEqual(isRedirectToddleacademy, "true")
    ) {
      await dispatch(_redirectToToddleAcademy({ userId }));
    }
    //Note:Prevent getConfigurations from being on public route because it was logging out the user and auth token was incorrect.
    if (user_type !== "parent" && !isPublicPlatformRoute()) {
      await dispatch(_getUserPermissions());
    }

    dispatch(setLoadingState(false));
    dispatch(setIsUserConfigurationsFetched(true));
  };
};

const _doTransition = () => {
  return (dispatch, getState) => {
    const currentPath = getCurrentPathname();

    const query = getCurrentQuery();

    const { metadata, user_id: userId = "" } = query;

    const userData = getUserInfo();

    /**params are valid if they do not contain user id or user id is same current logged in user's id.
     * Second scenario will occur when user is part of multiple organizations.
     */
    const isValidUser = !userId || userId === userData.id;

    let metadataObj = {};
    try {
      metadataObj = metadata ? JSON.parse(metadata) : {};
    } catch {}
    const redirectUrl = _.get(query, "redirect_url");
    if (redirectUrl) {
      try {
        const decodedUrl = decodeURIComponent(_.trim(redirectUrl));

        // Validate redirect URL for security:
        // - Block javascript:, data:, vbscript: protocols
        // - Block protocol-relative URLs (//example.com)
        // - Block URLs containing newlines or carriage returns
        if (
          /^(javascript|data|vbscript):/i.test(decodedUrl) ||
          decodedUrl.startsWith("//") ||
          /[\n\r]/.test(decodedUrl)
        ) {
          throw new Error("Invalid URL");
        }

        // Validate if the decoded URL is safe to redirect
        if (
          _.startsWith(decodedUrl, "https://") &&
          isRedirectUrlSafe(decodedUrl)
        ) {
          window.location.href = decodedUrl;
          return;
        }

        if (_.startsWith(decodedUrl, "/")) {
          // If the decoded URL is an absolute path, treat it as a relative route
          dispatch(goToRelativeRoute({ route: _.trim(redirectUrl) }));
          return;
        }

        // fallback to platform route
        dispatch(goToRelativeRoute({ route: "/platform" }));
      } catch (error) {
        // fallback redirect
        dispatch(goToRelativeRoute({ route: "/platform" }));
      }
    } else if (
      !_.isEmpty(query) &&
      metadataObj.authenticatedRoute &&
      isValidUser
    ) {
      dispatch(handleQueryParameters({ query }));
    } else if (currentPath == "/") {
      //check for family invite code, if present preserve it
      const familyInviteCode = _.get(metadataObj, "inviteCode");
      if (!_.isEmpty(familyInviteCode)) {
        dispatch(
          goToRelativeRoute({
            route: `platform?preserve_query_params=true&&config=${JSON.stringify(
              { metadata: metadataObj }
            )}`,
            queryParamsToPreserve: ["preserve_query_params", "config"],
          })
        );
      } else {
        dispatch(goToRelativeRoute({ route: "platform" }));
      }
    } else if (
      _.includes(currentPath, "/sso/microsoft") ||
      _.includes(currentPath, "/sso/canny")
    ) {
      return;
    } else if (_.includes(currentPath, "/sso")) {
      dispatch(goToRelativeRoute({ route: "../../" }));
    } else if (_.includes(currentPath, "/oauth/v2/authorize")) {
      const clientId = _.get(query, "client_id");
      const state = _.get(query, "state");

      if (_.isEmpty(clientId)) {
        return;
      }

      if (_.get(query, "usertype", "") === "parent") {
        setTimeout(() => {
          dispatch(
            authorizeUserWithOauth2({
              clientId,
              state,
              openInNewTab: false,
            })
          );
        }, [3000]);
      } else {
        dispatch(
          authorizeUserWithOauth2({
            clientId,
            state,
            openInNewTab: false,
          })
        );
      }
    } else if (_.startsWith(currentPath, "/account/")) {
      dispatch(goToRoute({ route: "platform" }));
    }
  };
};

export const _getUserPermissions = () => {
  return async (dispatch, getState) => {
    try {
      const portalType = "PLANNER";
      const userInfo = getUserInfo({ portalType });
      const organizationId = userInfo.org_id;

      // Fetch only the FF value so ACLStore knows which path to take
      // Bulk config/preference fetching is handled by WithConfigurationsAndPreferences in ChildrenPage
      if (userInfo.user_type === "staff") {
        await dispatch(
          fetchUserConfigurations({
            organizationId,
            configurations: [ENABLE_CONFIGURATION_FETCHING_OPTIMISATION],
          })
        );
      }
    } catch (e) {
      console.error(e);
    }
  };
};

export const getCumulativeGlobalHeaderHeight = () => {
  return (dispatch, getState) => {
    const banners = _.get(getState(), "login.banners", []);

    const isGlobalHeaderVisible = _.get(
      getState(),
      "login.globalHeader.isVisible"
    );

    const bannerHeightMap = {
      ACADEMIC_YEAR_ALERT: 32,
      DOWNTIME_ALERT: 28,
      USER_IMPERSONATION_ALERT: 56,
      MFA_INFO_ALERT: 32,
    };

    let totalHeight = _.reduce(
      banners,
      (result, banner) => {
        return result + bannerHeightMap[banner];
      },
      0
    );

    if (isGlobalHeaderVisible) {
      totalHeight += 40; //Add height of global header
    }

    return totalHeight;
  };
};

export const enableGlobalHeader = () => {
  return (dispatch, getState) => {
    const isValidRouteForGlobalHeader = _.get(
      getState(),
      "login.globalHeader.isValidRoute"
    );
    if (isValidRouteForGlobalHeader) {
      dispatch(setGlobalHeaderVisibility(true));
    }
  };
};

export const enableGlobalHeaderForCurrentRoute = () => {
  return dispatch => {
    dispatch(_setGlobalHeaderVisibilityOnCurrentRoute(true));
  };
};

export const disableGlobalHeader = () => {
  return dispatch => {
    dispatch(setGlobalHeaderVisibility(false));
  };
};

export const disableGlobalHeaderForCurrentRoute = () => {
  return dispatch => {
    dispatch(_setGlobalHeaderVisibilityOnCurrentRoute(false));
  };
};

export const showDemoDayBanner = () => {
  return dispatch => {
    dispatch(setDemoDayVisibility(true));
  };
};

export const hideDemoDayBanner = () => {
  return dispatch => {
    dispatch(setDemoDayVisibility(false));
  };
};

export const loginWithRedirectUrl = (state, accessToken, error) => {
  return dispatch => {
    const type = state.get("type");
    const method = state.get("method");
    const userType = state.get("userType");

    // * Navigating to redirect URL
    const redirectURL = new URL(state.get("redirectUrl"));
    const redirectTo = `${redirectURL.pathname}${redirectURL.search}`;
    if (!_.isEmpty(redirectTo)) {
      dispatch(goToRelativeRoute({ route: redirectTo, type: "push" }));
    }

    // * Showing toast and Handling `Failure` redirect
    if (error) {
      let errorMsg = null;
      if (method === "googleV2") {
        if (error == "google_script_not_loaded") {
          errorMsg = "toastMsgs:something_went_wrong";
        } else if (error != "popup_closed_by_user") {
          errorMsg = "toastMsgs:click_again_to_login";
        }
      } else if (method === "microsoft") {
        if (error === "interaction_in_progress") {
          errorMsg = "toastMsgs:microsoft_interaction_in_progress";
        } else {
          errorMsg = "toastMsgs:something_went_wrong";
        }
      }

      if (errorMsg) {
        // * Dispatching toast msg after 500ms, waiting for app to initiate
        setTimeout(() => {
          dispatch(setToastMsg({ msg: errorMsg, type: "warning" }));
        }, 500);
      }

      dispatch(updateCurrentScreen({ type, userType }));
      return;
    }

    // * Authenticating user and Handling `Success` redirect
    if (accessToken) {
      dispatch(
        authenticateUserWithServer({
          method,
          userType,
          idToken: accessToken,
        })
      );
    }
  };
};

export const logoutUser = async ({
  redirectionOption,
  redirectUri,
  logoutAllDevices = false,
  skipSloCall = false,
  skipLogoutCall = false,
} = {}) => {
  store.dispatch(setLoadingState(true));
  const userInfo = getUserInfo();

  if (!(isUserLoggedOut() || skipLogoutCall)) {
    try {
      const { id } = userInfo;
      const result = await client.mutate({
        mutation: logoutUserMutation,
        variables: {
          input: { id, logoutFromAllDevices: logoutAllDevices },
        },
      });

      const isSuccess = _.get(
        result,
        "data.platform.logoutUser.isSuccess",
        false
      );
      if (!isSuccess) throw new Error();
    } catch (e) {
      store.dispatch(setLoadingState(false));
      /**
       * If user is already logged out from BE, then this error will be thrown from
       * BE while calling logout mutation. In that case, we should not show toast msg
       * because user is already logged out.
       */
      if (e.message !== LOGGED_OUT_USER_ERROR) {
        store.dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
      return false;
    }
  }

  // Raven.setUserContext();

  // Cleanup WalkMe script, if any
  WalkMeManager.cleanup();

  stopChatWidget();
  await client.clearStore();

  // get org workspace details to redirect user to school scoped login page after logout
  const orgWorkspaceDetails = getOrgWorkSpaceDetails();

  //Delete JWT, Teacher Prefs
  clearLocalStorage();

  // remove class and unit flow data from indexedDb
  clearEntityFlowStore();

  Cookies.remove("lhst", {
    domain: cloudFrontDomain || ".toddleapp.com",
  });
  Cookies.remove("rhst", {
    domain: cloudFrontDomain || ".toddleapp.com",
  });
  Cookies.remove("CloudFront-Key-Pair-Id", {
    domain: cloudFrontDomain || ".toddleapp.com",
  });
  Cookies.remove("CloudFront-Policy", {
    domain: cloudFrontDomain || ".toddleapp.com",
  });
  Cookies.remove("CloudFront-Signature", {
    domain: cloudFrontDomain || ".toddleapp.com",
  });

  //Reset ACL Store // Optional
  ACLStore.clearAclStore();
  //Mark user as Logging in Redux //Optional
  // setting user as Logging will result into displaying default loginpage before orgworkspace login-page
  if (
    _.isEmpty(_.get(orgWorkspaceDetails, "schoolCode", null)) ||
    userInfo?.idpCode
  ) {
    store.dispatch(logoutUserSuccess());
  }

  //Remove User Identity from EventTracker
  recordEvent({ eventName: "Logged Out" });
  clearIdentity();

  await Microsoft.logout();
  //Refresh Browser
  // dispatch(replace("/"));

  //Remove apollo cache data from external storage and pause persisting further
  persistor.pause();
  await client.clearStore();
  await persistor.purge();

  store.dispatch(setLoadingState(false));

  const params = new URLSearchParams(window?.location?.search || "");
  const isEmailSource = params.get("source") === "email";

  try {
    window.productFruits.services.destroy();
  } catch (err) {
    console.error("error in destroying productFruits", err);
  }

  if (!skipSloCall && userInfo?.idpCode) {
    try {
      // Store organization details in Redux and localStorage in case of SAML Login
      if (!_.isEmpty(orgWorkspaceDetails)) {
        store.dispatch(
          setOrgWorkSpaceDetailsInReduxAndStorage(orgWorkspaceDetails)
        );
      }

      const responseData = await axios.get(
        getBackendServerUrl({
          path: `/auth/v2/saml/slo?idpCode=${userInfo.idpCode}`,
        }),
        { headers: { Authorization: `Bearer ${userInfo.token}` } }
      );

      const redirectUrl = _.get(responseData, "data.redirectUrl", "");

      const fallbackUrl = !_.isEmpty(
        _.get(orgWorkspaceDetails, "schoolCode", null)
      )
        ? `/account/${orgWorkspaceDetails.schoolCode}`
        : "/";

      window.location.replace(redirectUrl || fallbackUrl);
    } catch (e) {
      const fallbackUrl = !_.isEmpty(
        _.get(orgWorkspaceDetails, "schoolCode", null)
      )
        ? `/account/${orgWorkspaceDetails.schoolCode}`
        : "/";

      window.location.href = fallbackUrl;
    }
  } else if (redirectionOption === "integration_sso" || redirectUri) {
    window.location.href = redirectUri;
  } else if (isEmailSource) {
    // worked for new mails which have encoded data
    // not removing source email from here because it's used inside navigation module
    if (hasQueryParam(window.location.href, "locationContext")) {
      window.location.href = `/?redirect_url=${encodeURIComponent(
        window.location.href
      )}`;
    } else {
      //  worked for old emails
      window.location.href = `/?redirect_url=${encodeURIComponent(
        removeQueryParam(window.location.href, "source")
      )}`;
    }
  } else if (!_.isEmpty(_.get(orgWorkspaceDetails, "schoolCode", null))) {
    window.location.href = `/account/${orgWorkspaceDetails.schoolCode}`;
  } else {
    window.location.href = "/";
  }
};

export const authorizeUserWithEsfSentral = ({
  feature,
  studentId = null,
  openInNewTab = false,
  curriculumProgramId = null,
  shouldRefetchQuery = false,
}) => {
  return async (dispatch, getState) => {
    const isSentralUrlOpenInNewTabEnabled = getIsSentralUrlOpenInNewTabEnabled();
    const shouldOpenInNewTab = openInNewTab || isSentralUrlOpenInNewTabEnabled;

    dispatch(
      setSentralPortalDetails({
        loader: true,
      })
    );
    const state = getState();
    const userType = getUserType(state);
    const curriculumId = getSelectedCurriculumId(state);
    const platformName = sentralPortalFeatureMapping[feature];
    const sentralActivity = getIsSentralLoginActivityLogged();

    const operationType =
      sentralActivity.isLoginTriggered || shouldOpenInNewTab
        ? FETCH_PLATFORM_URL
        : FETCH_AUTH_CODE_URL;

    const response = await client.query({
      query: verifySentralOauthRedirectQuery,
      variables: {
        input: {
          serviceName: SENTRAL,
          operationType,
          platformName,
          studentId,
          curriculumId: curriculumId || curriculumProgramId,
        },
      },
      fetchPolicy: "network-only",
    });

    if (shouldRefetchQuery) {
      await client.query({
        query: fetchSentralUserNotificationStateQuery,
        variables: {
          input: {
            curriculumIds: [curriculumId],
          },
        },
        fetchPolicy: "network-only",
      });
    }

    const { isSuccess, redirectUrl, message } = _.get(
      response,
      "data.integration.verifySentralOauthRedirect",
      {}
    );

    if (isSuccess) {
      if (shouldOpenInNewTab) {
        setIsSentralLoginActivityLogged({
          openInNewTab: true,
          isLoginTriggered: sentralActivity.isLoginTriggered,
        });
        dispatch(openLinkInNewTab({ url: redirectUrl }));
        return;
      }

      const shouldShowPortal =
        sentralActivity.isLoginTriggered || userType === "student";

      if (shouldShowPortal) {
        dispatch(
          setSentralPortalDetails({
            url: redirectUrl,
            isVisible: true,
            verificationFailed: false,
            platformName: "",
          })
        );
      } else {
        setIsSentralLoginActivityLogged({
          ...sentralActivity,
          studentId,
          platformName,
          curriculumId: curriculumId || curriculumProgramId,
          adminUrl: curriculumProgramId ? window.location.pathname : "", // Store current admin portal URL to enable proper redirection after Sentral authentication
        });
        window.location.href = redirectUrl;
      }
    } else {
      dispatch(setToastMsg(message));

      const portalDetails =
        platformName === "student_profile"
          ? { verificationFailed: true, isVisible: true, loader: false }
          : { isVisible: false, loader: false };

      dispatch(setSentralPortalDetails(portalDetails));
    }
  };
};

export const verifySentralOauthRedirectUrl = async () => {
  try {
    store.dispatch(setLoadingState(true));
    const sentralActivity = getIsSentralLoginActivityLogged();
    setIsSentralLoginActivityLogged({
      ...sentralActivity,
      firstTimeLogin: false,
    });
    store.dispatch(
      setSentralPortalDetails({
        isVisible: true,
        studentId: sentralActivity.studentId,
        platformName: sentralActivity.platformName,
        loader: true,
      })
    );
    store.dispatch(setLoadingState(false));
  } catch (error) {
    store.dispatch(handleApiError({ error }));
    store.dispatch(setLoadingState(false));
  }
};

// Shifted here from Community Module
export const isUserAuthenticatedForAction = data => {
  return async (dispatch, getState) => {
    const userLoggedIn = _.get(getState(), "login.userLoggedIn");
    return !!userLoggedIn;
  };
};

export const verifyMfa = ({ authenticationCode, mfaToken, method }) => {
  return async dispatch => {
    await dispatch(setLoadingState(true));
    const requestNonce = generateRandomNonce(12, "base64");
    const url = "/auth/verifyMfa";
    const requestObj = {
      authenticationCode,
      mfaToken,
      method,
      otpVerificationNonce: requestNonce,
    };

    const response = await dispatch(makeApiRequest({ url, requestObj }));
    const data = _.get(response, "data", {});
    if (!_.has(data, "token")) {
      await dispatch(setLoadingState(false));
      return;
    }

    const validateNonce = validateRequestNonce({
      token: _.get(data, "token"),
      requestNonce,
    });
    if (!_.get(validateNonce, "isValid")) {
      dispatch(setLoadingState(false));
      dispatch(setToastMsg("toastMsgs:request_verification_failed"));
      return;
    }
    await dispatch(setLoadingState(false));
    return data;
  };
};

export const generateMfaOtp = requestObj => {
  return async dispatch => {
    const url = "/auth/generateMfaOtp";
    const response = await dispatch(makeApiRequest({ url, requestObj }));
    const data = _.get(response, "data", {});
    return data;
  };
};

/**
 * @param {Object} args
 * @param {String} args.token - signed revoke token from the URL query param
 * @returns {Promise<{ isSuccess: true | false, message : String }>}
 */
export const revokeSessionApi = async ({ token }) => {
  const response = await axios.post(
    getBackendServerUrl({ path: "/auth/revokeSession" }),
    { token }
  );
  return _.get(response, "data", {});
};

// Auto-generated exports
export {
  generateOTP,
  generateEmailOTP,
  verifyOTP,
  authenticateUserWithIdentityPool,
  _onSAUserAuthentication,
  _onUserAuthentication,
  _redirectToToddleAcademy,
  _doTransition,
};
